/* PetRide — CRO behaviours (vanilla, self-contained). */
(function () {
  'use strict';
  var d = document;

  /* Header — inject a "Shop Now" CTA pill (header is shared Dawn markup; add once) */
  (function () {
    var hIcons = d.querySelector('.header__icons');
    if (!hIcons || d.querySelector('.ccx-head-cta')) return;
    var cta = d.createElement('a');
    cta.className = 'ccx-head-cta';
    cta.href = '/pages/shop';
    cta.innerHTML = '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.4" stroke-linecap="round" stroke-linejoin="round"><path d="M6 7h13l-1.3 9.4a2 2 0 0 1-2 1.6H9.3a2 2 0 0 1-2-1.6L6 7z"/><path d="M9 7a3 3 0 0 1 6 0"/></svg><span>Shop Now</span>';
    hIcons.insertBefore(cta, hIcons.firstChild);
  })();

  /* Mark the current page's nav item (static header is duplicated — no server-side active state) */
  (function () {
    function norm(p) { return p.replace(/index\.html$/, '').replace(/\/+$/, '') || '/'; }
    var here = norm(location.pathname);
    if (here === '/') return;
    [].forEach.call(d.querySelectorAll('.header__inline-menu .header__menu-item--main'), function (a) {
      if (a.tagName === 'A' && norm(a.pathname) === here) a.classList.add('ccx-nav-current');
    });
  })();

  /* Mobile nav drawer — own controller. The header restyle left the theme's drawer JS
     non-functional, and the drawer's position:fixed was trapped/clipped by a transformed
     header ancestor. We relocate the drawer (with a backdrop) to <body> so it escapes any
     transformed ancestor, then drive open/close via html.cce-nav-open. */
  (function () {
    var det = d.getElementById('Details-menu-drawer-container');
    var drawer = d.getElementById('menu-drawer');
    if (!det || !drawer || drawer.getAttribute('data-cce-moved')) return;
    var summary = det.querySelector('summary.header__icon--menu') || det.querySelector('summary');
    var root = d.documentElement;
    var backdrop = d.createElement('div');
    backdrop.className = 'cce-nav-backdrop';
    function cceRelocate() {
      if (drawer.getAttribute('data-cce-moved')) return;
      d.body.appendChild(backdrop);
      d.body.appendChild(drawer);               /* escape any transformed/overflow ancestor */
      drawer.setAttribute('data-cce-moved', '1');
    }
    /* Defer relocating the drawer out of its <details> until window.load, so the theme's
       DOMContentLoaded accessibility pass (global.js summary loop, which reads
       summary.nextElementSibling) still sees the drawer as the summary's sibling. Relocating
       earlier orphaned the summary and threw, halting global.js before it defined ModalDialog. */
    if (d.readyState === 'complete') cceRelocate(); else window.addEventListener('load', cceRelocate);
    function openNav() { root.classList.add('cce-nav-open'); drawer.style.setProperty('transform', 'translateX(0)', 'important'); }
    function closeNav() { root.classList.remove('cce-nav-open'); drawer.style.setProperty('transform', 'translateX(-120%)', 'important'); }
    if (summary) summary.addEventListener('click', function (e) {
      e.preventDefault(); e.stopImmediatePropagation();
      if (root.classList.contains('cce-nav-open')) closeNav(); else openNav();
    }, true);
    backdrop.addEventListener('click', closeNav);
    /* close button: handle in CAPTURE + stop propagation so the theme's now-broken close
       handler never runs and throws. */
    d.addEventListener('click', function (e) {
      if (e.target.closest('.menu-drawer__close-btn, .menu-drawer__close-menu-btn')) {
        e.preventDefault(); e.stopImmediatePropagation(); closeNav();
      }
    }, true);
    drawer.addEventListener('click', function (e) {
      if (e.target.closest('a.menu-drawer__menu-item')) closeNav();   /* let the link navigate, just close the drawer */
    });
    d.addEventListener('keydown', function (e) { if (e.key === 'Escape') closeNav(); });
  })();

  /* Buy-box "you save" line — refresh when the offer quantity changes */
  (function () {
    var ob = d.querySelector('.cc-offer-box');
    if (!ob) return;
    var line = ob.querySelector('[data-save-line]');
    if (!line) return;
    ob.addEventListener('click', function (e) {
      var opt = e.target.closest('.cc-offer-option'); if (!opt) return;
      var s = opt.getAttribute('data-save'); if (s) line.textContent = "That's " + s + ' back in your pocket today 🎉';
    });
  })();

  /* FAQ accordion */
  d.addEventListener('click', function (e) {
    var q = e.target.closest('.ccx-faq__q'); if (!q) return;
    var item = q.closest('.ccx-faq__item'); var a = item.querySelector('.ccx-faq__a');
    var open = item.classList.toggle('is-open');
    a.style.maxHeight = open ? (a.scrollHeight + 'px') : '';
  });

  /* Reveal on scroll */
  if ('IntersectionObserver' in window) {
    var io = new IntersectionObserver(function (es) {
      es.forEach(function (en) { if (en.isIntersecting) { en.target.classList.add('is-in'); io.unobserve(en.target); } });
    }, { threshold: 0.12, rootMargin: '0px 0px -40px 0px' });
    d.querySelectorAll('.ccx-reveal').forEach(function (el) { io.observe(el); });
  } else {
    d.querySelectorAll('.ccx-reveal').forEach(function (el) { el.classList.add('is-in'); });
  }

  /* Sticky shop bar — item #5: show the sticky bar(s) ONLY when the MAIN add-to-cart
     button is OUT of view, hide when it's in view (IntersectionObserver, no scroll
     thresholds). On load while the ATC is visible, the sticky stays hidden. */
  var sticky = d.querySelector('.ccx-sticky');
  /* the MAIN add-to-cart button: id starts with ProductSubmitButton- (Dawn), with fallbacks */
  var mainAtc = d.querySelector('[id^="ProductSubmitButton-"]') ||
    d.querySelector('.main-product-atc, .product-form__submit, button[name="add"]');
  var themeSticky = d.querySelector('sticky-atc');

  function setStickyShown(show) {
    if (sticky) sticky.classList.toggle('is-shown', show);
    if (themeSticky) themeSticky.classList.toggle('is-shown', show);
  }

  if ((sticky || themeSticky) && mainAtc && 'IntersectionObserver' in window) {
    setStickyShown(false);                       /* hidden on load while ATC is visible */
    var atcIo = new IntersectionObserver(function (entries) {
      entries.forEach(function (en) {
        /* show only when the main ATC is OUT of view, hide when any part is in view */
        setStickyShown(!en.isIntersecting);
      });
    }, { threshold: 0, rootMargin: '0px 0px 0px 0px' });
    atcIo.observe(mainAtc);
  } else if (sticky) {
    /* Pages without a main ATC (e.g. home): fall back to a simple scroll threshold,
       hidden near the footer. */
    var nearBottom = function () { var y = window.pageYOffset || d.documentElement.scrollTop; return (window.innerHeight + y) > (d.body.scrollHeight - 200); };
    var onScroll = function () {
      var y = window.pageYOffset || d.documentElement.scrollTop;
      if (y > 620 && !nearBottom()) sticky.classList.add('is-shown'); else sticky.classList.remove('is-shown');
    };
    window.addEventListener('scroll', onScroll, { passive: true }); onScroll();
  }

  /* Sticky add-to-cart popup is built by the cart engine at the bottom of this file (page-accurate config + real cart). */

  /* Cross-sell add buttons (visual only — no real cart on the static clone). SKIP any button wired to the
     REAL cart + fold-in drawer, which shows "Adding to cart" + spinner then a green "Added ✓": the
     homepage/chrome quick-add (home-hyper.js) and the shop grid/bundle/pair/modal (shop-hyper.js, .sh-root). */
  d.addEventListener('click', function (e) {
    var b = e.target.closest('[data-add]'); if (!b) return;
    if (b.closest('.cc-home, .cc-chrome-top, .cc-chrome-foot, .sh-root')) return;
    var added = b.classList.toggle('is-added');
    b.textContent = added ? '✓ Added' : '+ Add';
  });


  /* PDP bundle selector (visual — selecting updates the CTA; scrolls to the buy box, no real cart) */
  var bundle = d.getElementById('ccxBundle');
  if (bundle) {
    var bcta = d.getElementById('ccxBundleCta');
    bundle.addEventListener('click', function (e) {
      var opt = e.target.closest('.ccx-bundle__opt'); if (!opt) return;
      bundle.querySelectorAll('.ccx-bundle__opt').forEach(function (o) {
        o.classList.remove('is-sel'); var i = o.querySelector('input'); if (i) i.checked = false;
      });
      opt.classList.add('is-sel'); var inp = opt.querySelector('input'); if (inp) inp.checked = true;
      if (bcta) {
        var nm = opt.querySelector('.ccx-bundle__info b').firstChild.textContent.trim();
        bcta.textContent = 'Add ' + nm + ' — $' + opt.getAttribute('data-price');
      }
    });
  }

  /* Site-wide fade-in — NORMAL, on CONTENT blocks (headings, media, cards, text),
     not whole sections. Homepage CRO uses its own .ccx-reveal; this covers theme
     content. Above-the-fold shows instantly; reduced-motion respected. */
  if ('IntersectionObserver' in window && !matchMedia('(prefers-reduced-motion: reduce)').matches) {
    var fxIo = new IntersectionObserver(function (es) {
      es.forEach(function (en) { if (en.isIntersecting) { en.target.classList.add('is-in'); fxIo.unobserve(en.target); } });
    }, { threshold: 0.12, rootMargin: '0px 0px -50px 0px' });
    var vh = window.innerHeight || 800;
    var EXC = '.header,.header-wrapper,.footer,.ccx,.ccx-section,#shopify-section-cc-cro-home,.horizontal-ticker,' +
      '.shopify-section-group-header-group,.shopify-section-group-footer-group,' +
      '#shopify-section-promo-popup,#shopify-section-scroll-to-top-btn,#shopify-section-global-music-player';
    var SEL = 'h1,h2,h3,h4,img,video,picture,blockquote,.button,' +
      '[class*="card"],[class*="__item"],[class*="__card"],[class*="__col"],[class*="grid"]>*,p,li';
    var fxMain = d.querySelector('main') || d.body;
    [].slice.call(fxMain.querySelectorAll(SEL)).forEach(function (el) {
      if (el.closest(EXC)) return;
      if (el.hasAttribute('data-ccx-fx') || el.closest('[data-ccx-fx]')) return; // dedupe to outermost block
      if (el.offsetParent === null) return;
      var r = el.getBoundingClientRect();
      if (r.height < 20) return;
      el.setAttribute('data-ccx-fx', '');
      el.classList.add('ccx-fx');
      if (r.top < vh * 0.92) el.classList.add('is-in'); else fxIo.observe(el);
    });
    setTimeout(function () { d.querySelectorAll('.ccx-fx:not(.is-in)').forEach(function (el) { if (el.getBoundingClientRect().top < window.innerHeight) el.classList.add('is-in'); }); }, 1400);
  }
})();

;(function(){function initShipAnim(){var notes=document.querySelectorAll(".cc-shipping-note");if(!notes.length)return;if(!("IntersectionObserver" in window)){notes.forEach(function(n){n.classList.add("cc-ship-anim","cc-ship-anim--play");});return;}var io=new IntersectionObserver(function(es){es.forEach(function(e){if(e.isIntersecting){e.target.classList.add("cc-ship-anim","cc-ship-anim--play");io.unobserve(e.target);}});},{threshold:0.45});notes.forEach(function(n){io.observe(n);});}if(document.readyState==="loading")document.addEventListener("DOMContentLoaded",initShipAnim);else initShipAnim();})();

/* Gift photos — click to view enlarged in a popup */
;(function(){
  function init(){
    var imgs=document.querySelectorAll('.cc-offer-gift__ic img');
    if(!imgs.length)return;
    var overlay,imgEl,capEl;
    function build(){
      overlay=document.createElement('div');
      overlay.className='cc-giftbox';
      overlay.setAttribute('aria-hidden','true');
      overlay.innerHTML='<div class="cc-giftbox__inner"><button class="cc-giftbox__close" aria-label="Close">&times;</button><img class="cc-giftbox__img" alt=""><div class="cc-giftbox__cap"></div></div>';
      document.body.appendChild(overlay);
      imgEl=overlay.querySelector('.cc-giftbox__img');
      capEl=overlay.querySelector('.cc-giftbox__cap');
      overlay.addEventListener('click',function(e){if(e.target===overlay||e.target.classList.contains('cc-giftbox__close'))close();});
      document.addEventListener('keydown',function(e){if(e.key==='Escape')close();});
    }
    function open(src,cap){
      if(!overlay)build();
      imgEl.src=src;imgEl.alt=cap||'';capEl.textContent=cap||'';
      overlay.classList.add('is-open');overlay.setAttribute('aria-hidden','false');
      document.body.style.overflow='hidden';
    }
    function close(){if(!overlay)return;overlay.classList.remove('is-open');overlay.setAttribute('aria-hidden','true');document.body.style.overflow='';}
    imgs.forEach(function(img){
      img.setAttribute('role','button');
      img.setAttribute('tabindex','0');
      function go(){var cap='';var row=img.closest('.cc-offer-gift');if(row){var st=row.querySelector('.cc-offer-gift__t strong');if(st)cap=st.textContent.trim();}open(img.currentSrc||img.src,cap);}
      img.addEventListener('click',go);
      img.addEventListener('keydown',function(e){if(e.key==='Enter'||e.key===' '){e.preventDefault();go();}});
    });
  }
  if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',init);else init();
})();

/* ============================================================
   PetRide — client-side cart + page-accurate sticky + upsells
   (appended to cro.js; runs on every page)
   ============================================================ */
(function () {
  'use strict';
  var LS = 'petride_cart_mirror';
  var IMG = 'https://cdn.shopify.com/s/files/1/0957/0847/9772/files/';
  var ASSET = 'https://cdn.shopify.com/s/files/1/0957/0847/9772/t/4/assets/';

  var CATALOG = {
    'full-seat-cover': { title: 'PetRide Hard Bottom Car Seat Cover', url: '/products/full-seat-cover/', img: ASSET + 'petride-full-seat-cover-hero-v3.png', type: 'bundle', quick: 'buy1',
      options: [ { key: 'buy1', label: 'Buy 1', sub: '1 cover', units: 1, price: 119.95 }, { key: 'buy2', label: 'Buy 2', sub: '2-pack', units: 2, price: 215.91 }, { key: 'buy3', label: 'Buy 3', sub: '3-pack', units: 3, price: 287.88 } ] },
    'travel-bed': { title: 'PetRide Custom-Fit Travel Bed', url: '/products/travel-bed/', img: ASSET + 'petride-travel-bed-checkered.png', type: 'bundle', quick: 'buy1',
      options: [ { key: 'buy1', label: 'Buy 1', sub: '1 bed', units: 1, price: 109.95 }, { key: 'buy2', label: 'Buy 2', sub: '2-pack', units: 2, price: 197.91 }, { key: 'buy3', label: 'Buy 3', sub: '3-pack', units: 3, price: 263.88 } ] },
    'single-seat-cover': { title: 'PetRide Hard Bottom Single Seat Cover', url: '/products/single-seat-cover/', img: ASSET + 'petride-single-seat-cover-1-v2.png', type: 'qbreaks', quick: 'single',
      options: [ { key: 'single', label: 'Single', sub: '1 cover', units: 1, price: 109.95 }, { key: 'buy2', label: 'Buy 2', sub: '2-pack', units: 2, price: 197.91 }, { key: 'buy3', label: 'Buy 3', sub: '3-pack', units: 3, price: 263.88 } ] },
    'steady-ride-system': { title: 'PetRide SteadyRide Travel System', url: '/products/steady-ride-system/', img: 'https://cdn.shopify.com/s/files/1/0957/0847/9772/files/swap-swap-petride-steady-ride-system-1-v3.webp?v=1783308443', type: 'qbreaks', quick: 'single',
      options: [ { key: 'single', label: 'Single', sub: 'full system', units: 1, price: 179.90 }, { key: 'buy2', label: 'Buy 2', sub: '2-pack', units: 2, price: 323.82 }, { key: 'buy3', label: 'Buy 3', sub: '3-pack', units: 3, price: 431.76 } ] },
    'pet-water-fountain': { title: 'PetRide Pet Water Fountain', url: '/products/pet-water-fountain/', img: ASSET + 'petride-pwf-1-v3.png', type: 'variant', quick: 'filters-4', variantName: 'Filter Bundle',
      options: [ { key: 'filters-4', label: '4 Filters', sub: '8 weeks', units: 1, price: 129.95, variant: '4 Filters (8 Weeks)' }, { key: 'filters-12', label: '12 Filters', sub: '24 weeks · most popular', units: 1, price: 149.95, variant: '12 Filters (24 Weeks)' }, { key: 'filters-24', label: '24 Filters', sub: '48 weeks · best value', units: 1, price: 159.95, variant: '24 Filters (48 Weeks)' }, { key: 'filters-96', label: '96 Filters', sub: '192 weeks', units: 1, price: 249.95, variant: '96 Filters (192 Weeks)' } ] },
    'replacement-filters': { title: 'PetRide Replacement Filters', url: '/products/replacement-filters/', img: ASSET + 'petride-replacement-filters-1-v3.png', type: 'qbreaks', quick: 'single',
      options: [ { key: 'single', label: 'Single', sub: '1 pack', units: 1, price: 24.95 }, { key: 'buy2', label: 'Buy 2', sub: '2-pack', units: 2, price: 44.91 } ] }
  };

  /* product-aware cross-sell graph (ordered by relevance) */
  var COMPLEMENTS = {
    'full-seat-cover': ['travel-bed', 'steady-ride-system', 'pet-water-fountain'],
    'single-seat-cover': ['travel-bed', 'steady-ride-system', 'pet-water-fountain'],
    'travel-bed': ['full-seat-cover', 'steady-ride-system', 'pet-water-fountain'],
    'steady-ride-system': ['pet-water-fountain', 'travel-bed'],
    'pet-water-fountain': ['travel-bed'],
    'replacement-filters': ['pet-water-fountain']
  };

  /* sold-out products: never recommended or added as an upsell */
  var SOLD_OUT = { 'full-seat-cover': 1, 'single-seat-cover': 1, 'travel-bed': 1, 'steady-ride-system': 1, 'pet-water-fountain': 1, 'replacement-filters': 1 }; /* 29 Oct 2026: whole store sold out */

  var d = document;
  var money = function (n) { return '$' + n.toFixed(2); };
  var opt = function (dir, key) { var p = CATALOG[dir]; if (!p) return null; for (var i = 0; i < p.options.length; i++) if (p.options[i].key === key) return p.options[i]; return null; };

  /* ---- state ----
     The REAL Shopify cart (/cart.js response) is the source of truth. We keep a
     localStorage mirror (petride_cart_mirror) only so the drawer UI stays consistent if a
     render fires before the first network fetch resolves. */
  var shopifyCart = null;            /* last /cart.js response */
  function load() { try { return JSON.parse(localStorage.getItem(LS)) || []; } catch (e) { return []; } }
  function save(c) { try { localStorage.setItem(LS, JSON.stringify(c)); } catch (e) {} }

  /* Mirror the real Shopify cart into the local model (handle/units) so upsell
     recommendations and any pre-fetch render stay consistent. */
  function mirror(cart) {
    var c = [];
    (cart && cart.items || []).forEach(function (it) {
      var dir = it.handle;
      if (dir && CATALOG[dir]) { c.push({ dir: dir, key: CATALOG[dir].quick, qty: it.quantity }); }
    });
    save(c);
  }

  /* fetch the real cart and re-render everything */
  function refreshCart(open) {
    return fetch('/cart.js', { headers: { 'Accept': 'application/json' } })
      .then(function (r) { return r.json(); })
      .then(function (cart) { shopifyCart = cart; mirror(cart); renderAll(); if (open) openDrawer(); return cart; })
      .catch(function (err) { try { console.warn('[cro] /cart.js failed', err); } catch (e) {} });
  }
  /* Expose refresh+open so home-hyper.js's homepage/sticky quick-add can open the SAME fold-in cart drawer (no /cart redirect, no flash of the old cart page). */
  try { window.__croRefreshCart = refreshCart; } catch (e) {}

  /* Add-to-Cart button loading state: "Adding to cart" + spinner while the add is in flight. */
  var atcOrigLabel = null;
  function atcEl() { return d.querySelector('[id^="ProductSubmitButton"]') || d.querySelector('form[action*="/cart/add"] button[name="add"]'); }
  function setAtcLoading(on) {
    var atc = atcEl(); if (!atc) return;
    var lbl = atc.querySelector('.main-atc__label__text') || atc.querySelector('.main-atc__label') || atc;
    if (on) {
      if (atcOrigLabel === null) atcOrigLabel = lbl.innerHTML;
      lbl.innerHTML = 'Adding to cart <span class="cc-spin"></span>';
      atc.setAttribute('aria-busy', 'true');
    } else {
      if (atcOrigLabel !== null) { lbl.innerHTML = atcOrigLabel; atcOrigLabel = null; }
      atc.removeAttribute('aria-busy');
    }
  }
  /* Success state: once the item is in the cart and the drawer is open, flip the ATC to a green
     "Added ✓", then revert to the original label. Unified with the shop + homepage quick-add UX. */
  var atcRevT = null;
  function setAtcAdded() {
    var atc = atcEl(); if (!atc) return;
    var lbl = atc.querySelector('.main-atc__label__text') || atc.querySelector('.main-atc__label') || atc;
    if (atcOrigLabel === null) atcOrigLabel = lbl.innerHTML;   // sticky-bar add path skips setAtcLoading
    lbl.innerHTML = 'Added <span aria-hidden="true">✓</span>';
    atc.classList.add('cc-atc-added');
    atc.removeAttribute('aria-busy');
    if (atcRevT) clearTimeout(atcRevT);
    atcRevT = setTimeout(function () {
      atc.classList.remove('cc-atc-added');
      if (atcOrigLabel !== null) { lbl.innerHTML = atcOrigLabel; atcOrigLabel = null; }
      atcRevT = null;
    }, 2600);
  }

  /* POST a variant id + quantity to the real Shopify cart, then refresh + open the drawer.
     NO redirect to checkout. */
  function addToShopify(variantId, quantity) {
    if (!variantId) { try { console.warn('[cro] add skipped: no variant id'); } catch (e) {} setAtcLoading(false); return; }
    fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify({ items: [{ id: Number(variantId), quantity: quantity || 1 }] })
    }).then(function (r) {
      if (!r.ok) throw new Error('add.js ' + r.status);
      return r.json();
    }).then(function () {
      return refreshCart(true);
    }).then(function () { setAtcAdded(); }).catch(function (err) {
      try { console.warn('[cro] /cart/add.js failed', err); } catch (e) {}
      setAtcLoading(false);
      /* graceful fallback: still try to surface whatever is in the real cart */
      refreshCart(true);
    });
  }

  /* update a line quantity on the real cart by its line key (Shopify /cart/change.js) */
  function changeLine(key, quantity) {
    fetch('/cart/change.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify({ id: key, quantity: quantity })
    }).then(function (r) { return r.json(); })
      .then(function (cart) { shopifyCart = cart; mirror(cart); renderAll(); })
      .catch(function (err) { try { console.warn('[cro] /cart/change.js failed', err); } catch (e) {} refreshCart(false); });
  }

  /* ---- recommendations (derive in-cart handles from the real cart) ---- */
  function cartHandles() {
    var inCart = {};
    if (shopifyCart && shopifyCart.items) { shopifyCart.items.forEach(function (it) { if (it.handle) inCart[it.handle] = true; }); }
    else { load().forEach(function (l) { inCart[l.dir] = true; }); }
    return inCart;
  }
  function recommend() {
    var inCart = cartHandles();
    var keys = Object.keys(inCart);
    if (!keys.length) return [];
    var out = [], seen = {};
    keys.forEach(function (dir) { (COMPLEMENTS[dir] || []).forEach(function (r) { if (!inCart[r] && !seen[r] && CATALOG[r] && !SOLD_OUT[r]) { seen[r] = true; out.push(r); } }); });
    return out.slice(0, 3);
  }

  /* ---- drawer rendering ---- */
  function drawer() { return d.querySelector('cart-drawer'); }
  /* render a line from the REAL Shopify cart item (item.key/title/quantity/url/image/final_line_price) */
  function lineRow(it) {
    var img = cartImg(it) || it.image || (it.featured_image && it.featured_image.url) || '';
    var price = (it.final_line_price != null ? it.final_line_price : it.line_price) / 100;
    var optTxt = (it.variant_title && it.variant_title !== 'Default Title') ? it.variant_title : '';
    return '<div class="cc-ci" data-key="' + it.key + '">' +
      '<a href="' + (it.url || '#') + '"><img class="cc-ci__img" src="' + img + '" alt=""></a>' +
      '<div class="cc-ci__info"><a class="cc-ci__title" href="' + (it.url || '#') + '">' + (it.product_title || it.title) + '</a>' +
      (optTxt ? '<div class="cc-ci__opt">' + optTxt + '</div>' : '') +
      '<div class="cc-ci__price">' + money(price) + (it.quantity > 1 ? ' <em>&times;' + it.quantity + '</em>' : '') + '</div></div>' +
      '<div class="cc-ci__side"><button type="button" class="cc-ci__rm" data-rm aria-label="Remove">&times;</button>' +
      '<div class="cc-ci__qty"><button type="button" data-step="-1" aria-label="Decrease">&minus;</button><span>' + it.quantity + '</span><button type="button" data-step="1" aria-label="Increase">+</button></div></div>' +
      '</div>';
  }
  function upsellBlock() {
    var recs = recommend(); if (!recs.length) return '';
    var cards = recs.map(function (dir) {
      var p = CATALOG[dir], o = opt(dir, p.quick);
      return '<div class="cc-up__card"><img src="' + sized(p.img, 200) + '" alt="" data-up-img="' + dir + '"><div class="cc-up__t"><b>' + p.title + '</b><span>' + money(o.price) + '</span></div>' +
        '<button type="button" class="cc-up__add" data-up-add="' + dir + '">Add</button></div>';
    }).join('');
    return '<div class="cc-up"><div class="cc-up__h">Complete the setup &mdash; pairs perfectly</div>' + cards + '</div>';
  }
  /* upgrade the upsell card thumbnails from live PetRide product data (resilient to
     stale hardcoded filenames) — fetch each product's featured_image once and cache it. */
  var prodImgCache = {};
  function upgradeUpsellImages() {
    d.querySelectorAll('img[data-up-img]').forEach(function (img) {
      var dir = img.getAttribute('data-up-img');
      if (prodImgCache[dir]) { if (prodImgCache[dir] !== 'pending') img.src = prodImgCache[dir]; return; }
      prodImgCache[dir] = 'pending';
      fetch('/products/' + dir + '.js', { headers: { 'Accept': 'application/json' } })
        .then(function (r) { return r.json(); })
        .then(function (prod) {
          var url = prod.featured_image || (prod.images && prod.images[0]);
          if (url) { prodImgCache[dir] = sized(url, 300); var t = d.querySelector('img[data-up-img="' + dir + '"]'); if (t) t.src = prodImgCache[dir]; } else { prodImgCache[dir] = null; }
        })
        .catch(function () { prodImgCache[dir] = null; });
    });
  }
  /* ---- CRO drawer stack: footer (built once) + native express wallets + native payment icons ---- */
  var PAY_ICONS = '<ul class="payment-badges" role="list"><li class="list-payment__item"><svg class="icon icon--full-color" xmlns="http://www.w3.org/2000/svg" role="img" viewBox="0 0 38 24" width="38" height="24" aria-labelledby="pi-afterpay"><title id="pi-afterpay">Afterpay</title><path fill="#b2fce4" d="M35 0H3C1.3 0 0 1.3 0 3v18c0 1.7 1.4 3 3 3h32c1.7 0 3-1.3 3-3V3c0-1.7-1.4-3-3-3z"/><path d="m27.4 6.8-2.7-1.6-2.7-1.6c-1.8-1-4.1.3-4.1 2.4v.4c0 .2.1.4.3.5l1.3.7c.4.2.8-.1.8-.5v-.8c0-.4.4-.7.8-.5l2.5 1.4 2.4 1.5c.4.2.4.7 0 .9l-2.5 1.4-2.5 1.6c-.4.2-.8-.1-.8-.5v-.4c0-2.1-2.3-3.4-4.1-2.4l-2.7 1.6-2.7 1.6c-1.8 1-1.8 3.7 0 4.7l2.7 1.6 2.7 1.6c1.8 1 4.1-.3 4.1-2.4v-.4c0-.2-.1-.4-.3-.5l-1.3-.7c-.4-.2-.8.1-.8.5v.8c0 .4-.4.7-.8.5l-2.5-1.4-2.5-1.5c-.4-.2-.4-.7 0-.9l2.5-1.4 2.5-1.4c.4-.2.8.1.8.5v.4c0 2.1 2.3 3.4 4.1 2.4l2.7-1.6 2.7-1.6c1.9-1.2 1.9-3.8.1-4.9z"/></svg></li><li class="list-payment__item"><svg class="icon icon--full-color" xmlns="http://www.w3.org/2000/svg" role="img" aria-labelledby="pi-american_express" viewBox="0 0 38 24" width="38" height="24"><title id="pi-american_express">American Express</title><path fill="#000" d="M35 0H3C1.3 0 0 1.3 0 3v18c0 1.7 1.4 3 3 3h32c1.7 0 3-1.3 3-3V3c0-1.7-1.4-3-3-3Z" opacity=".07"/><path fill="#006FCF" d="M35 1c1.1 0 2 .9 2 2v18c0 1.1-.9 2-2 2H3c-1.1 0-2-.9-2-2V3c0-1.1.9-2 2-2h32Z"/><path fill="#FFF" d="M22.012 19.936v-8.421L37 11.528v2.326l-1.732 1.852L37 17.573v2.375h-2.766l-1.47-1.622-1.46 1.628-9.292-.02Z"/><path fill="#006FCF" d="M23.013 19.012v-6.57h5.572v1.513h-3.768v1.028h3.678v1.488h-3.678v1.01h3.768v1.531h-5.572Z"/><path fill="#006FCF" d="m28.557 19.012 3.083-3.289-3.083-3.282h2.386l1.884 2.083 1.89-2.082H37v.051l-3.017 3.23L37 18.92v.093h-2.307l-1.917-2.103-1.898 2.104h-2.321Z"/><path fill="#FFF" d="M22.71 4.04h3.614l1.269 2.881V4.04h4.46l.77 2.159.771-2.159H37v8.421H19l3.71-8.421Z"/><path fill="#006FCF" d="m23.395 4.955-2.916 6.566h2l.55-1.315h2.98l.55 1.315h2.05l-2.904-6.566h-2.31Zm.25 3.777.875-2.09.873 2.09h-1.748Z"/><path fill="#006FCF" d="M28.581 11.52V4.953l2.811.01L32.84 9l1.456-4.046H37v6.565l-1.74.016v-4.51l-1.644 4.494h-1.59L30.35 7.01v4.51h-1.768Z"/></svg></li><li class="list-payment__item"><svg class="icon icon--full-color" version="1.1" xmlns="http://www.w3.org/2000/svg" role="img" x="0" y="0" width="38" height="24" viewBox="0 0 165.521 105.965" xml:space="preserve" aria-labelledby="pi-apple_pay"><title id="pi-apple_pay">Apple Pay</title><path fill="#000" d="M150.698 0H14.823c-.566 0-1.133 0-1.698.003-.477.004-.953.009-1.43.022-1.039.028-2.087.09-3.113.274a10.51 10.51 0 0 0-2.958.975 9.932 9.932 0 0 0-4.35 4.35 10.463 10.463 0 0 0-.975 2.96C.113 9.611.052 10.658.024 11.696a70.22 70.22 0 0 0-.022 1.43C0 13.69 0 14.256 0 14.823v76.318c0 .567 0 1.132.002 1.699.003.476.009.953.022 1.43.028 1.036.09 2.084.275 3.11a10.46 10.46 0 0 0 .974 2.96 9.897 9.897 0 0 0 1.83 2.52 9.874 9.874 0 0 0 2.52 1.83c.947.483 1.917.79 2.96.977 1.025.183 2.073.245 3.112.273.477.011.953.017 1.43.02.565.004 1.132.004 1.698.004h135.875c.565 0 1.132 0 1.697-.004.476-.002.952-.009 1.431-.02 1.037-.028 2.085-.09 3.113-.273a10.478 10.478 0 0 0 2.958-.977 9.955 9.955 0 0 0 4.35-4.35c.483-.947.789-1.917.974-2.96.186-1.026.246-2.074.274-3.11.013-.477.02-.954.022-1.43.004-.567.004-1.132.004-1.699V14.824c0-.567 0-1.133-.004-1.699a63.067 63.067 0 0 0-.022-1.429c-.028-1.038-.088-2.085-.274-3.112a10.4 10.4 0 0 0-.974-2.96 9.94 9.94 0 0 0-4.35-4.35A10.52 10.52 0 0 0 156.939.3c-1.028-.185-2.076-.246-3.113-.274a71.417 71.417 0 0 0-1.431-.022C151.83 0 151.263 0 150.698 0z" /><path fill="#FFF" d="M150.698 3.532l1.672.003c.452.003.905.008 1.36.02.793.022 1.719.065 2.583.22.75.135 1.38.34 1.984.648a6.392 6.392 0 0 1 2.804 2.807c.306.6.51 1.226.645 1.983.154.854.197 1.783.218 2.58.013.45.019.9.02 1.36.005.557.005 1.113.005 1.671v76.318c0 .558 0 1.114-.004 1.682-.002.45-.008.9-.02 1.35-.022.796-.065 1.725-.221 2.589a6.855 6.855 0 0 1-.645 1.975 6.397 6.397 0 0 1-2.808 2.807c-.6.306-1.228.511-1.971.645-.881.157-1.847.2-2.574.22-.457.01-.912.017-1.379.019-.555.004-1.113.004-1.669.004H14.801c-.55 0-1.1 0-1.66-.004a74.993 74.993 0 0 1-1.35-.018c-.744-.02-1.71-.064-2.584-.22a6.938 6.938 0 0 1-1.986-.65 6.337 6.337 0 0 1-1.622-1.18 6.355 6.355 0 0 1-1.178-1.623 6.935 6.935 0 0 1-.646-1.985c-.156-.863-.2-1.788-.22-2.578a66.088 66.088 0 0 1-.02-1.355l-.003-1.327V14.474l.002-1.325a66.7 66.7 0 0 1 .02-1.357c.022-.792.065-1.717.222-2.587a6.924 6.924 0 0 1 .646-1.981c.304-.598.7-1.144 1.18-1.623a6.386 6.386 0 0 1 1.624-1.18 6.96 6.96 0 0 1 1.98-.646c.865-.155 1.792-.198 2.586-.22.452-.012.905-.017 1.354-.02l1.677-.003h135.875" /><g><g><path fill="#000" d="M43.508 35.77c1.404-1.755 2.356-4.112 2.105-6.52-2.054.102-4.56 1.355-6.012 3.112-1.303 1.504-2.456 3.959-2.156 6.266 2.306.2 4.61-1.152 6.063-2.858" /><path fill="#000" d="M45.587 39.079c-3.35-.2-6.196 1.9-7.795 1.9-1.6 0-4.049-1.8-6.698-1.751-3.447.05-6.645 2-8.395 5.1-3.598 6.2-.95 15.4 2.55 20.45 1.699 2.5 3.747 5.25 6.445 5.151 2.55-.1 3.549-1.65 6.647-1.65 3.097 0 3.997 1.65 6.696 1.6 2.798-.05 4.548-2.5 6.247-5 1.95-2.85 2.747-5.6 2.797-5.75-.05-.05-5.396-2.101-5.446-8.251-.05-5.15 4.198-7.6 4.398-7.751-2.399-3.548-6.147-3.948-7.447-4.048" /></g><g><path fill="#000" d="M78.973 32.11c7.278 0 12.347 5.017 12.347 12.321 0 7.33-5.173 12.373-12.529 12.373h-8.058V69.62h-5.822V32.11h14.062zm-8.24 19.807h6.68c5.07 0 7.954-2.729 7.954-7.46 0-4.73-2.885-7.434-7.928-7.434h-6.706v14.894z" /><path fill="#000" d="M92.764 61.847c0-4.809 3.665-7.564 10.423-7.98l7.252-.442v-2.08c0-3.04-2.001-4.704-5.562-4.704-2.938 0-5.07 1.507-5.51 3.82h-5.252c.157-4.86 4.731-8.395 10.918-8.395 6.654 0 10.995 3.483 10.995 8.89v18.663h-5.38v-4.497h-.13c-1.534 2.937-4.914 4.782-8.579 4.782-5.406 0-9.175-3.222-9.175-8.057zm17.675-2.417v-2.106l-6.472.416c-3.64.234-5.536 1.585-5.536 3.95 0 2.288 1.975 3.77 5.068 3.77 3.95 0 6.94-2.522 6.94-6.03z" /><path fill="#000" d="M120.975 79.652v-4.496c.364.051 1.247.103 1.715.103 2.573 0 4.029-1.09 4.913-3.899l.52-1.663-9.852-27.293h6.082l6.863 22.146h.13l6.862-22.146h5.927l-10.216 28.67c-2.34 6.577-5.017 8.735-10.683 8.735-.442 0-1.872-.052-2.261-.157z" /></g></g></svg></li><li class="list-payment__item"><svg class="icon icon--full-color" viewBox="0 0 38 24" xmlns="http://www.w3.org/2000/svg" role="img" width="38" height="24" aria-labelledby="pi-master"><title id="pi-master">Mastercard</title><path opacity=".07" d="M35 0H3C1.3 0 0 1.3 0 3v18c0 1.7 1.4 3 3 3h32c1.7 0 3-1.3 3-3V3c0-1.7-1.4-3-3-3z"/><path fill="#fff" d="M35 1c1.1 0 2 .9 2 2v18c0 1.1-.9 2-2 2H3c-1.1 0-2-.9-2-2V3c0-1.1.9-2 2-2h32"/><circle fill="#EB001B" cx="15" cy="12" r="7"/><circle fill="#F79E1B" cx="23" cy="12" r="7"/><path fill="#FF5F00" d="M22 12c0-2.4-1.2-4.5-3-5.7-1.8 1.3-3 3.4-3 5.7s1.2 4.5 3 5.7c1.8-1.2 3-3.3 3-5.7z"/></svg></li><li class="list-payment__item"><svg class="icon icon--full-color" viewBox="0 0 38 24" xmlns="http://www.w3.org/2000/svg" width="38" height="24" role="img" aria-labelledby="pi-paypal"><title id="pi-paypal">PayPal</title><path opacity=".07" d="M35 0H3C1.3 0 0 1.3 0 3v18c0 1.7 1.4 3 3 3h32c1.7 0 3-1.3 3-3V3c0-1.7-1.4-3-3-3z"/><path fill="#fff" d="M35 1c1.1 0 2 .9 2 2v18c0 1.1-.9 2-2 2H3c-1.1 0-2-.9-2-2V3c0-1.1.9-2 2-2h32"/><path fill="#003087" d="M23.9 8.3c.2-1 0-1.7-.6-2.3-.6-.7-1.7-1-3.1-1h-4.1c-.3 0-.5.2-.6.5L14 15.6c0 .2.1.4.3.4H17l.4-3.4 1.8-2.2 4.7-2.1z"/><path fill="#3086C8" d="M23.9 8.3l-.2.2c-.5 2.8-2.2 3.8-4.6 3.8H18c-.3 0-.5.2-.6.5l-.6 3.9-.2 1c0 .2.1.4.3.4H19c.3 0 .5-.2.5-.4v-.1l.4-2.4v-.1c0-.2.3-.4.5-.4h.3c2.1 0 3.7-.8 4.1-3.2.2-1 .1-1.8-.4-2.4-.1-.5-.3-.7-.5-.8z"/><path fill="#012169" d="M23.3 8.1c-.1-.1-.2-.1-.3-.1-.1 0-.2 0-.3-.1-.3-.1-.7-.1-1.1-.1h-3c-.1 0-.2 0-.2.1-.2.1-.3.2-.3.4l-.7 4.4v.1c0-.3.3-.5.6-.5h1.3c2.5 0 4.1-1 4.6-3.8v-.2c-.1-.1-.3-.2-.5-.2h-.1z"/></svg></li><li class="list-payment__item"><svg class="icon icon--full-color" xmlns="http://www.w3.org/2000/svg" role="img" viewBox="0 0 38 24" width="38" height="24" aria-labelledby="pi-shopify_pay"><title id="pi-shopify_pay">Shop Pay</title><path opacity=".07" d="M35 0H3C1.3 0 0 1.3 0 3v18c0 1.7 1.4 3 3 3h32c1.7 0 3-1.3 3-3V3c0-1.7-1.4-3-3-3z" fill="#000"/><path d="M35.889 0C37.05 0 38 .982 38 2.182v19.636c0 1.2-.95 2.182-2.111 2.182H2.11C.95 24 0 23.018 0 21.818V2.182C0 .982.95 0 2.111 0H35.89z" fill="#5A31F4"/><path d="M9.35 11.368c-1.017-.223-1.47-.31-1.47-.705 0-.372.306-.558.92-.558.54 0 .934.238 1.225.704a.079.079 0 00.104.03l1.146-.584a.082.082 0 00.032-.114c-.475-.831-1.353-1.286-2.51-1.286-1.52 0-2.464.755-2.464 1.956 0 1.275 1.15 1.597 2.17 1.82 1.02.222 1.474.31 1.474.705 0 .396-.332.582-.993.582-.612 0-1.065-.282-1.34-.83a.08.08 0 00-.107-.035l-1.143.57a.083.083 0 00-.036.111c.454.92 1.384 1.437 2.627 1.437 1.583 0 2.539-.742 2.539-1.98s-1.155-1.598-2.173-1.82v-.003zM15.49 8.855c-.65 0-1.224.232-1.636.646a.04.04 0 01-.069-.03v-2.64a.08.08 0 00-.08-.081H12.27a.08.08 0 00-.08.082v8.194a.08.08 0 00.08.082h1.433a.08.08 0 00.081-.082v-3.594c0-.695.528-1.227 1.239-1.227.71 0 1.226.521 1.226 1.227v3.594a.08.08 0 00.081.082h1.433a.08.08 0 00.081-.082v-3.594c0-1.51-.981-2.577-2.355-2.577zM20.753 8.62c-.778 0-1.507.24-2.03.588a.082.082 0 00-.027.109l.632 1.088a.08.08 0 00.11.03 2.5 2.5 0 011.318-.366c1.25 0 2.17.891 2.17 2.068 0 1.003-.736 1.745-1.669 1.745-.76 0-1.288-.446-1.288-1.077 0-.361.152-.657.548-.866a.08.08 0 00.032-.113l-.596-1.018a.08.08 0 00-.098-.035c-.799.299-1.359 1.018-1.359 1.984 0 1.46 1.152 2.55 2.76 2.55 1.877 0 3.227-1.313 3.227-3.195 0-2.018-1.57-3.492-3.73-3.492zM28.675 8.843c-.724 0-1.373.27-1.845.746-.026.027-.069.007-.069-.029v-.572a.08.08 0 00-.08-.082h-1.397a.08.08 0 00-.08.082v8.182a.08.08 0 00.08.081h1.433a.08.08 0 00.081-.081v-2.683c0-.036.043-.054.069-.03a2.6 2.6 0 001.808.7c1.682 0 2.993-1.373 2.993-3.157s-1.313-3.157-2.993-3.157zm-.271 4.929c-.956 0-1.681-.768-1.681-1.783s.723-1.783 1.681-1.783c.958 0 1.68.755 1.68 1.783 0 1.027-.713 1.783-1.681 1.783h.001z" fill="#fff"/></svg></li><li class="list-payment__item"><svg class="icon icon--full-color" viewBox="0 0 38 24" xmlns="http://www.w3.org/2000/svg" role="img" width="38" height="24" aria-labelledby="pi-visa"><title id="pi-visa">Visa</title><path opacity=".07" d="M35 0H3C1.3 0 0 1.3 0 3v18c0 1.7 1.4 3 3 3h32c1.7 0 3-1.3 3-3V3c0-1.7-1.4-3-3-3z"/><path fill="#fff" d="M35 1c1.1 0 2 .9 2 2v18c0 1.1-.9 2-2 2H3c-1.1 0-2-.9-2-2V3c0-1.1.9-2 2-2h32"/><path d="M28.3 10.1H28c-.4 1-.7 1.5-1 3h1.9c-.3-1.5-.3-2.2-.6-3zm2.9 5.9h-1.7c-.1 0-.1 0-.2-.1l-.2-.9-.1-.2h-2.4c-.1 0-.2 0-.2.2l-.3.9c0 .1-.1.1-.1.1h-2.1l.2-.5L27 8.7c0-.5.3-.7.8-.7h1.5c.1 0 .2 0 .2.2l1.4 6.5c.1.4.2.7.2 1.1.1.1.1.1.1.2zm-13.4-.3l.4-1.8c.1 0 .2.1.2.1.7.3 1.4.5 2.1.4.2 0 .5-.1.7-.2.5-.2.5-.7.1-1.1-.2-.2-.5-.3-.8-.5-.4-.2-.8-.4-1.1-.7-1.2-1-.8-2.4-.1-3.1.6-.4.9-.8 1.7-.8 1.2 0 2.5 0 3.1.2h.1c-.1.6-.2 1.1-.4 1.7-.5-.2-1-.4-1.5-.4-.3 0-.6 0-.9.1-.2 0-.3.1-.4.2-.2.2-.2.5 0 .7l.5.4c.4.2.8.4 1.1.6.5.3 1 .8 1.1 1.4.2.9-.1 1.7-.9 2.3-.5.4-.7.6-1.4.6-1.4 0-2.5.1-3.4-.2-.1.2-.1.2-.2.1zm-3.5.3c.1-.7.1-.7.2-1 .5-2.2 1-4.5 1.4-6.7.1-.2.1-.3.3-.3H18c-.2 1.2-.4 2.1-.7 3.2-.3 1.5-.6 3-1 4.5 0 .2-.1.2-.3.2M5 8.2c0-.1.2-.2.3-.2h3.4c.5 0 .9.3 1 .8l.9 4.4c0 .1 0 .1.1.2 0-.1.1-.1.1-.1l2.1-5.1c-.1-.1 0-.2.1-.2h2.1c0 .1 0 .1-.1.2l-3.1 7.3c-.1.2-.1.3-.2.4-.1.1-.3 0-.5 0H9.7c-.1 0-.2 0-.2-.2L7.9 9.5c-.2-.2-.5-.5-.9-.6-.6-.3-1.7-.5-1.9-.5L5 8.2z" fill="#142688"/></svg></li><li class="list-payment__item"><svg class="icon icon--full-color" xmlns="http://www.w3.org/2000/svg" role="img" viewBox="0 0 38 24" width="38" height="24" aria-labelledby="pi-google_pay"><title id="pi-google_pay">Google Pay</title><path d="M35 0H3C1.3 0 0 1.3 0 3v18c0 1.7 1.4 3 3 3h32c1.7 0 3-1.3 3-3V3c0-1.7-1.4-3-3-3z" fill="#000" opacity=".07"/><path d="M35 1c1.1 0 2 .9 2 2v18c0 1.1-.9 2-2 2H3c-1.1 0-2-.9-2-2V3c0-1.1.9-2 2-2h32" fill="#FFF"/><path d="M18.093 11.976v3.2h-1.018v-7.9h2.691a2.447 2.447 0 0 1 1.747.692 2.28 2.28 0 0 1 .11 3.224l-.11.116c-.47.447-1.098.69-1.747.674l-1.673-.006zm0-3.732v2.788h1.698c.377.012.741-.135 1.005-.404a1.391 1.391 0 0 0-1.005-2.354l-1.698-.03zm6.484 1.348c.65-.03 1.286.188 1.778.613.445.43.682 1.03.65 1.649v3.334h-.969v-.766h-.049a1.93 1.93 0 0 1-1.673.931 2.17 2.17 0 0 1-1.496-.533 1.667 1.667 0 0 1-.613-1.324 1.606 1.606 0 0 1 .613-1.336 2.746 2.746 0 0 1 1.698-.515c.517-.02 1.03.093 1.49.331v-.208a1.134 1.134 0 0 0-.417-.901 1.416 1.416 0 0 0-.98-.368 1.545 1.545 0 0 0-1.319.717l-.895-.564a2.488 2.488 0 0 1 2.182-1.06zM23.29 13.52a.79.79 0 0 0 .337.662c.223.176.5.269.785.263.429-.001.84-.17 1.146-.472.305-.286.478-.685.478-1.103a2.047 2.047 0 0 0-1.324-.374 1.716 1.716 0 0 0-1.03.294.883.883 0 0 0-.392.73zm9.286-3.75l-3.39 7.79h-1.048l1.281-2.728-2.224-5.062h1.103l1.612 3.885 1.569-3.885h1.097z" fill="#5F6368"/><path d="M13.986 11.284c0-.308-.024-.616-.073-.92h-4.29v1.747h2.451a2.096 2.096 0 0 1-.9 1.373v1.134h1.464a4.433 4.433 0 0 0 1.348-3.334z" fill="#4285F4"/><path d="M9.629 15.721a4.352 4.352 0 0 0 3.01-1.097l-1.466-1.14a2.752 2.752 0 0 1-4.094-1.44H5.577v1.17a4.53 4.53 0 0 0 4.052 2.507z" fill="#34A853"/><path d="M7.079 12.05a2.709 2.709 0 0 1 0-1.735v-1.17H5.577a4.505 4.505 0 0 0 0 4.075l1.502-1.17z" fill="#FBBC04"/><path d="M9.629 8.44a2.452 2.452 0 0 1 1.74.68l1.3-1.293a4.37 4.37 0 0 0-3.065-1.183 4.53 4.53 0 0 0-4.027 2.5l1.502 1.171a2.715 2.715 0 0 1 2.55-1.875z" fill="#EA4335"/></svg></li></ul>';
  /* Build the CRO footer stack ONCE inside the drawer footer. Dawn's native totals + CTA are hidden;
     the "Proceed to Checkout" button is homed inside the stack. Native wallets are injected separately. */
  function buildDrawerFoot() {
    var footer = d.querySelector('cart-drawer .drawer__footer');
    if (!footer || d.getElementById('cc-foot')) return;
    var dawnTotals = footer.querySelector('.cart-drawer__footer'); if (dawnTotals) dawnTotals.style.display = 'none';
    var stack = d.createElement('div'); stack.id = 'cc-foot'; stack.className = 'cc-foot';
    stack.innerHTML =
      '<div class="cc-foot__social"><span class="cc-foot__stars">&#9733;&#9733;&#9733;&#9733;&#9733;</span><b>4.9</b><span>from 1,000+ Aussie dog owners</span></div>' +
      '<div class="cc-foot__sum">' +
        '<div class="cc-foot__row"><span>Subtotal</span><span id="cc-foot-sub"></span></div>' +
        '<div class="cc-foot__row cc-foot__row--free"><span>Shipping</span><b id="cc-foot-ship">FREE</b></div>' +
        '<div class="cc-foot__row cc-foot__row--total"><span>Total</span><span id="cc-foot-total"></span></div>' +
      '</div>' +
      '<div class="cc-foot__reassure"><b>&#10003; Free shipping on all orders</b> &middot; 60-day money-back guarantee</div>' +
      '<div id="cc-foot-cta"></div>' +
      '<div class="cc-foot__or">or express checkout</div>' +
      '<div id="cc-foot-express" class="cc-foot__express"></div>' +
      '<div id="cc-foot-pay" class="cc-foot__pay">' + PAY_ICONS + '</div>';
    var ctas = footer.querySelector('.cart__ctas');
    if (ctas && ctas.parentNode === footer) footer.insertBefore(stack, ctas); else footer.appendChild(stack);
    var pc = d.getElementById('cc-proceed-checkout');
    if (!pc) { pc = d.createElement('button'); pc.id = 'cc-proceed-checkout'; pc.type = 'button'; pc.className = 'button cc-proceed-checkout'; pc.innerHTML = '<span class="button__label">Proceed to Checkout</span>'; }
    stack.querySelector('#cc-foot-cta').appendChild(pc);
    if (ctas) ctas.style.display = 'none';
  }
  /* Fetch the real cart page ONCE and lift its native <shopify-accelerated-checkout-cart> (Shop Pay /
     PayPal / GPay — whatever the store has enabled) into the express slot. Built once (data-cc-loaded)
     so the wallet element is never re-appended (that re-hydration is the "two PayPals" bug). The wallet
     checks out the current session cart, so it stays correct as line quantities change. */
  function ensureDrawerWallet() {
    var slot = d.getElementById('cc-foot-express');
    if (!slot || slot.getAttribute('data-cc-loaded')) return;
    slot.setAttribute('data-cc-loaded', '1');
    fetch('/cart', { headers: { 'Accept': 'text/html' } })
      .then(function (r) { return r.text(); })
      .then(function (html) {
        var doc = new DOMParser().parseFromString(html, 'text/html');
        var w = doc.querySelector('.cart__dynamic-checkout-buttons');
        if (w && w.querySelector('shopify-accelerated-checkout-cart, iframe, [class*="wallet-cart-button"]')) { slot.appendChild(d.importNode(w, true)); }
        else { hideExpress(slot); }
      })
      .catch(function () { hideExpress(slot); });
  }
  function hideExpress(slot) { if (slot) slot.style.display = 'none'; var orr = d.querySelector('.cc-foot__or'); if (orr) orr.style.display = 'none'; }
  /* ---- Empty cart = a re-engagement surface (full-stack "#10" from the CRO showcase): paw + title +
     message, "Popular right now" product cards, free-shipping reassurance, trust badges, Continue
     shopping + login. Injected ONCE into Dawn's .drawer__inner-empty; NATIVE product imagery + the
     real add-to-cart (data-up-add), so an "Add" flips the drawer straight to the full cart. ---- */
  var AUS_FLAG = '';
  var EC_POP = ['full-seat-cover', 'travel-bed', 'steady-ride-system'];
  var EC_NAME = { 'full-seat-cover': 'Full Seat Cover', 'travel-bed': 'Custom-Fit Travel Bed', 'steady-ride-system': 'SteadyRide System' };
  var EC_TAG = { 'full-seat-cover': 'Best-seller', 'steady-ride-system': 'Save 20%' };
  function ecCard(dir) {
    var p = CATALOG[dir]; if (!p || SOLD_OUT[dir]) return '';
    var o = opt(dir, p.quick) || p.options[0];
    var tag = EC_TAG[dir] ? '<span class="ec-card__tag">' + EC_TAG[dir] + '</span>' : '';
    return '<div class="ec-card">' + tag +
      '<a class="ec-card__img" href="' + p.url + '"><img src="' + sized(p.img, 300) + '" data-up-img="' + dir + '" alt=""></a>' +
      '<a class="ec-card__name" href="' + p.url + '">' + EC_NAME[dir] + '</a>' +
      '<span class="ec-card__p">' + money(o.price) + '</span>' +
      '<button type="button" class="ec-card__add" data-up-add="' + dir + '">Add</button>' +
    '</div>';
  }
  function buildEmptyCart() {
    var host = d.querySelector('cart-drawer .drawer__inner-empty');
    if (!host || host.getAttribute('data-cc-ec')) return;
    host.setAttribute('data-cc-ec', '1');
    host.innerHTML =
      '<button type="button" class="ec-close" aria-label="Close cart">&times;</button>' +
      '<div class="ec-body">' +
        '<div class="ec-paw">&#128062;</div>' +
        '<div class="ec-title">Your cart is empty</div>' +
        '<p class="ec-msg">Nothing in here yet, let&rsquo;s find something your dog will love.</p>' +
        
        '<div class="ec-fs"><span class="ec-fs__ic">&#128666;</span><div><b>Free shipping on all orders</b><span>No minimum, delivery&rsquo;s on us Australia-wide.</span></div></div>' +
        '<div class="ec-badges"><span class="ec-badge">' + AUS_FLAG + '<span>Aussie owned</span></span><span class="ec-badge"><i>&#128737;&#65039;</i> 60-day money-back</span></div>' +
        '<a class="ec-cta" href="/pages/shop">Continue shopping</a>' +
        '<div class="ec-account"><h4>Have an account?</h4><p><a href="/account/login">Log in</a> to check out faster.</p></div>' +
      '</div>';
    upgradeUpsellImages();
  }
  function renderAll() {
    var items = (shopifyCart && shopifyCart.items) || [];
    var count = shopifyCart ? shopifyCart.item_count : 0;
    var sub = shopifyCart ? (shopifyCart.items_subtotal_price != null ? shopifyCart.items_subtotal_price : shopifyCart.total_price) / 100 : 0;
    /* header badge */
    var bubbleHost = d.querySelector('#cart-icon-bubble');
    if (bubbleHost) {
      var b = bubbleHost.querySelector('.cart-count-bubble');
      if (!b) { b = d.createElement('span'); b.className = 'cart-count-bubble'; b.setAttribute('aria-hidden', 'true'); b.innerHTML = '<span></span>'; bubbleHost.appendChild(b); }
      b.firstChild.textContent = count;
      b.style.display = count > 0 ? '' : 'none';
    }
    /* Visible chrome cart badge (glass header — home-chrome/home-hyper render a hardcoded <span class="badge">;
       keep it in sync with the REAL cart count instead of frozen, and hide it when the cart is empty). */
    [].forEach.call(d.querySelectorAll('.hm-headacts button[title="Cart"] .badge'), function (bd) {
      bd.textContent = count;
      bd.style.display = count > 0 ? '' : 'none';
    });
    /* drawer items (rendered from the real cart) + the always-free shipping reassurance bar on top */
    var itemsHost = d.querySelector('#CartDrawer-CartItems');
    if (itemsHost) {
      var fsbar = itemsHost.querySelector('#cc-fsbar');
      if (!fsbar) {
        fsbar = d.createElement('div'); fsbar.id = 'cc-fsbar'; fsbar.className = 'cc-fsbar';
        fsbar.innerHTML = '<div class="cc-fsbar__top"><span class="cc-fsbar__lbl"></span><span class="cc-fsbar__chk">&#10003;</span></div><div class="cc-fsbar__track"><div class="cc-fsbar__fill"></div></div><div class="cc-fsbar__sub"></div>';
        itemsHost.insertBefore(fsbar, itemsHost.firstChild);
      }
      /* Free shipping on ALL orders (no threshold) — always show the unlocked/won reassurance. */
      (function () {
        var track = fsbar.querySelector('.cc-fsbar__track');
        if (track) track.style.background = 'linear-gradient(90deg,#22c55e 0%,#16a34a 100%)';
        var lbl = fsbar.querySelector('.cc-fsbar__lbl'), chk = fsbar.querySelector('.cc-fsbar__chk'), subEl = fsbar.querySelector('.cc-fsbar__sub');
        if (lbl) lbl.innerHTML = '&#127881; <b>Free shipping</b> on all orders';
        if (subEl) subEl.textContent = 'No minimum, delivery’s on us Australia-wide.';
        if (chk) chk.style.display = ''; fsbar.classList.add('is-won');
      })();
      var host = itemsHost.querySelector('#cc-cart-lines');
      if (!host) { host = d.createElement('div'); host.id = 'cc-cart-lines'; itemsHost.appendChild(host); }
      host.innerHTML = items.map(lineRow).join('');
      fsbar.style.display = count > 0 ? '' : 'none';
    }
    /* upsells */
    var slot = d.querySelector('.cart-drawer-items-and-upsell') || d.querySelector('.drawer__footer');
    if (slot) {
      var up = d.querySelector('#cc-upsell');
      if (!up) { up = d.createElement('div'); up.id = 'cc-upsell'; if (slot.classList.contains('drawer__footer')) slot.parentNode.insertBefore(up, slot); else slot.appendChild(up); }
      up.innerHTML = upsellBlock();
      upgradeUpsellImages();
    }
    /* Dawn's native totals is hidden; the CRO summary below shows Subtotal / Shipping FREE / Total. */
    var subEl = d.querySelector('.totals__subtotal-value'); if (subEl) subEl.textContent = money(sub) + ' AUD';
    /* Hide Dawn's native drawer checkout button — the CRO footer stack is the cart UI now. */
    var co = d.querySelector('#CartDrawer-Checkout, .cart__checkout-button'); if (co) co.style.display = 'none';
    /* Build the CRO footer stack once: social proof, Subtotal/Shipping FREE/Total, reassurance,
       Proceed to Checkout, express checkout (NATIVE Shopify wallets), guarantee badges, payment icons. */
    buildDrawerFoot();
    var pc = d.getElementById('cc-proceed-checkout');
    if (pc) { if (count > 0) pc.removeAttribute('disabled'); else pc.setAttribute('disabled', 'disabled'); }
    var subF = d.getElementById('cc-foot-sub'); if (subF) subF.textContent = money(sub);
    var totF = d.getElementById('cc-foot-total'); if (totF) totF.textContent = money(sub) + ' AUD';
    /* Free shipping on all orders — always FREE. */
    var shipF = d.getElementById('cc-foot-ship');
    if (shipF) { shipF.textContent = 'FREE'; shipF.classList.remove('cc-foot__ship--calc'); }
    var footEl = d.getElementById('cc-foot'); if (footEl) footEl.style.display = count > 0 ? '' : 'none';
    if (count > 0) ensureDrawerWallet();
    /* empty state */
    var cd = drawer();
    if (cd) {
      var empty = count <= 0;
      [cd, cd.querySelector('.drawer__inner'), cd.querySelector('cart-drawer-items')].forEach(function (n) { if (n) n.classList.toggle('is-empty', empty); });
      var emptyEl = cd.querySelector('.drawer__inner-empty'); if (emptyEl) emptyEl.style.display = empty ? '' : 'none';
    }
    /* populate the empty-cart re-engagement surface once (safe no-op when already built) */
    buildEmptyCart();
    /* keep the full-page /cart review in sync when the cart changes */
    renderCartPage();
  }
  function openDrawer() {
    var cd = drawer(); if (!cd) return;
    /* Respect the real cart state: only suppress the empty message when there ARE items.
       Opening an EMPTY cart (e.g. via the header icon) must show "Your cart is empty",
       never a blank drawer with a stuck "Loading…" placeholder. */
    var hasItems = !!(shopifyCart && shopifyCart.item_count > 0);
    [cd, cd.querySelector('.drawer__inner'), cd.querySelector('cart-drawer-items')].forEach(function (n) { if (n) n.classList.toggle('is-empty', !hasItems); });
    var emptyEl = cd.querySelector('.drawer__inner-empty'); if (emptyEl) emptyEl.style.display = hasItems ? 'none' : '';
    cd.classList.add('animate', 'active');
    d.body.classList.add('overflow-hidden');
  }
  function closeDrawer() { var cd = drawer(); if (!cd) return; cd.classList.remove('active'); d.body.classList.remove('overflow-hidden'); }
  d.addEventListener('click', function (e) { if (e.target.closest('#CartDrawer-Overlay, .cart-drawer__overlay, .drawer__close, .cart-drawer__close, .ec-close')) closeDrawer(); });
  d.addEventListener('keydown', function (e) { if (e.key === 'Escape') closeDrawer(); });

  /* find a real Shopify cart line by its key */
  function lineByKey(key) {
    if (!shopifyCart || !shopifyCart.items) return null;
    for (var i = 0; i < shopifyCart.items.length; i++) if (shopifyCart.items[i].key === key) return shopifyCart.items[i];
    return null;
  }
  /* add an upsell/complement product to the REAL cart by resolving its first available variant */
  function addUpsell(dir, btn) {
    if (!CATALOG[dir] || SOLD_OUT[dir]) return;
    if (btn) { btn.disabled = true; btn.textContent = 'Adding…'; }
    fetch('/products/' + dir + '.js', { headers: { 'Accept': 'application/json' } })
      .then(function (r) { return r.json(); })
      .then(function (prod) {
        var vs = prod.variants || [];
        var v = null; for (var i = 0; i < vs.length; i++) { if (vs[i].available) { v = vs[i]; break; } }
        if (!v && vs.length) v = vs[0];
        if (!v) throw new Error('no variant for ' + dir);
        addToShopify(v.id, 1);
      })
      .catch(function (err) { try { console.warn('[cro] upsell add failed', err); } catch (e) {} if (btn) { btn.disabled = false; btn.textContent = 'Add'; } });
  }

  /* drawer interactions (qty / remove / upsell add) — all drive the real Shopify cart */
  d.addEventListener('click', function (e) {
    var rm = e.target.closest('[data-rm]');
    var step = e.target.closest('[data-step]');
    var upAdd = e.target.closest('[data-up-add]');
    if (rm) { var r = rm.closest('.cc-ci'); if (r) changeLine(r.getAttribute('data-key'), 0); return; }
    if (step) { var s = step.closest('.cc-ci'); if (s) { var ln = lineByKey(s.getAttribute('data-key')); if (ln) changeLine(ln.key, Math.max(0, ln.quantity + parseInt(step.getAttribute('data-step'), 10))); } return; }
    if (upAdd) { e.preventDefault(); addUpsell(upAdd.getAttribute('data-up-add'), upAdd); return; }
  });

  /* Drawer "Checkout" -> go to the full-page /cart (the intermediary review page with the
     product breakdown + shipping estimate), NOT straight to Shopify checkout. Dawn's native
     cart JS is absent, so drive it ourselves. The /cart page's own button goes to /checkout. */
  d.addEventListener('click', function (e) {
    var co = e.target.closest('#CartDrawer-Checkout, [name="checkout"], .cart__checkout-button');
    if (!co) return;
    /* the /cart page's own checkout button (inside #cc-cartpage) -> real Shopify checkout */
    if (co.closest('#cc-cartpage')) { e.preventDefault(); e.stopPropagation(); window.location.href = '/checkout'; return; }
    /* the drawer checkout -> the /cart review page */
    if (!co.hasAttribute('disabled') && !co.classList.contains('disabled')) {
      e.preventDefault(); e.stopPropagation(); window.location.href = '/checkout';
    }
  }, true);

  /* the new "Proceed to Checkout" button -> straight to Shopify checkout (real cart carries over) */
  d.addEventListener('click', function (e) {
    var pc = e.target.closest('#cc-proceed-checkout');
    if (!pc || pc.hasAttribute('disabled')) return;
    e.preventDefault(); e.stopPropagation(); window.location.href = '/checkout';
  }, true);

  /* header cart icon -> open the fold-in drawer instead of navigating to the (now removed) /cart page */
  d.addEventListener('click', function (e) {
    var ci = e.target.closest('#cart-icon-bubble, a.header__icon--cart');
    if (!ci || ci.closest('cart-drawer, #cc-cartpage')) return;
    e.preventDefault(); e.stopPropagation();
    refreshCart(true);
  }, true);

  /* ---- current product selection (source of truth = page selector) ---- */
  var curDir = (function () { var m = location.pathname.match(/\/products\/([^\/]+)/); return (m && CATALOG[m[1]]) ? m[1] : null; })();
  var curKey = null;
  function optByUnits(u) { var p = CATALOG[curDir]; for (var i = 0; i < p.options.length; i++) if (p.options[i].units === u) return p.options[i]; return p.options[0]; }
  function optByVariant(v) { var p = CATALOG[curDir]; for (var i = 0; i < p.options.length; i++) if (p.options[i].variant === v) return p.options[i]; return p.options[0]; }
  function readSelection() {
    if (!curDir) return; var p = CATALOG[curDir], o;
    var v10a = d.querySelector('.v10-opt[aria-checked="true"]');
    if (v10a) { o = optByUnits(parseInt(v10a.getAttribute('data-qty'), 10)); }
    else if (p.type === 'bundle') { var a = d.querySelector('.cc-offer-option.is-active'); o = a ? optByUnits(parseInt(a.getAttribute('data-qty'), 10)) : p.options[0]; }
    else if (p.type === 'qbreaks') { var r = d.querySelector('input[name="quantity"]:checked'); o = r ? optByUnits(parseInt(r.value, 10)) : p.options[0]; }
    else { var s = d.querySelector('select[name="options[' + p.variantName + ']"]'); o = s ? optByVariant(s.value) : p.options[0]; }
    curKey = (o || p.options[0]).key; syncSticky(); syncFormQty();
  }
  /* listen to the page's own selectors */
  d.addEventListener('click', function (e) { if (curDir && CATALOG[curDir].type === 'bundle' && e.target.closest('.cc-offer-option')) setTimeout(readSelection, 0); });
  d.addEventListener('change', function (e) {
    if (!curDir) return; var p = CATALOG[curDir];
    if (p.type === 'qbreaks' && e.target.name === 'quantity') readSelection();
    if (p.type === 'variant' && e.target.matches && e.target.matches('select[name="options[' + p.variantName + ']"]')) readSelection();
  });
  /* drive the page selector from a chosen option key (keeps them in sync) */
  function driveSelector(key) {
    if (!curDir) return; var p = CATALOG[curDir], o = opt(curDir, key); if (!o) return;
    var v10el = d.querySelector('.v10-opt[data-qty="' + o.units + '"]');
    if (v10el) { v10SelectTier(v10el); }
    else if (p.type === 'bundle') { var el = d.querySelector('.cc-offer-option[data-qty="' + o.units + '"]'); if (el) el.click(); }
    else if (p.type === 'qbreaks') { var r = d.querySelector('input[name="quantity"][value="' + o.units + '"]'); if (r) { r.checked = true; r.dispatchEvent(new Event('change', { bubbles: true })); } }
    else { var s = d.querySelector('select[name="options[' + p.variantName + ']"]'); if (s) { s.value = o.variant; s.dispatchEvent(new Event('change', { bubbles: true })); } }
    curKey = key; syncSticky();
  }

  /* ---- v10 kit selector: tiers drive the cart quantity + reveal the free gifts inside the tier ---- */
  function v10SetReveal(optEl, on) {
    var g = optEl.querySelector('.v10-opt-gifts-clip');
    if (g) g.style.maxHeight = on ? (g.scrollHeight + 'px') : '0px';
  }
  function v10SelectTier(tier) {
    [].forEach.call(d.querySelectorAll('.v10-opt'), function (o) {
      var on = (o === tier);
      o.setAttribute('aria-checked', on ? 'true' : 'false');
      o.setAttribute('tabindex', on ? '0' : '-1');
      v10SetReveal(o, on);
    });
  }
  function v10RevealOpen() { var sel = d.querySelector('.v10-opt[aria-checked="true"]'); if (sel) v10SetReveal(sel, true); }
  d.addEventListener('click', function (e) {
    var tier = e.target.closest && e.target.closest('.v10-opt');
    if (tier) { v10SelectTier(tier); readSelection(); }
  });
  d.addEventListener('keydown', function (e) {
    var tier = e.target.closest && e.target.closest('.v10-opt'); if (!tier) return;
    var tiers = [].slice.call(d.querySelectorAll('.v10-opt')); var i = tiers.indexOf(tier);
    if (e.key === 'Enter' || e.key === ' ' || e.key === 'Spacebar') { e.preventDefault(); v10SelectTier(tier); readSelection(); }
    else if (e.key === 'ArrowDown' || e.key === 'ArrowRight') { e.preventDefault(); var n = tiers[(i + 1) % tiers.length]; v10SelectTier(n); n.focus(); readSelection(); }
    else if (e.key === 'ArrowUp' || e.key === 'ArrowLeft') { e.preventDefault(); var pv = tiers[(i - 1 + tiers.length) % tiers.length]; v10SelectTier(pv); pv.focus(); readSelection(); }
  });
  window.addEventListener('load', v10RevealOpen);
  window.addEventListener('resize', v10RevealOpen);

  /* derive the {variantId, quantity} to add from the page form + current selection.
     bundle/qbreaks: single variant, quantity = selected units.
     variant: the page select drives the form's variant id; quantity = 1. */
  function addFromForm(f) {
    if (!curDir) return;
    readSelection();
    var p = CATALOG[curDir];
    var idInput = f && (f.querySelector('input[name="id"]') || f.querySelector('[name="id"]'));
    var variantId = idInput && idInput.value;
    var o = opt(curDir, curKey) || p.options[0];
    var quantity = (p.type === 'variant') ? 1 : (o ? o.units : 1);
    addToShopify(variantId, quantity);
  }

  /* ---- main add-to-cart interception: drive the REAL Shopify cart, open the drawer,
     show upsells; NO redirect to checkout. ---- */
  d.addEventListener('submit', function (e) {
    var f = e.target.closest && e.target.closest('form[action*="/cart/add"]');
    if (!f || !curDir) return;
    e.preventDefault(); e.stopPropagation();
    setAtcLoading(true);
    addFromForm(f);
  }, true);

  /* ---- page-accurate sticky popup ---- */
  var stickyQA = null;
  function syncSticky() {
    if (!stickyQA) return;
    stickyQA.querySelectorAll('.ccx-qa__opt').forEach(function (o) { o.classList.toggle('is-sel', o.getAttribute('data-key') === curKey); });
    var o2 = opt(curDir, curKey); var addBtn = stickyQA.querySelector('.ccx-qa__add');
    if (addBtn && o2) addBtn.textContent = 'Add to cart · ' + money(o2.price);
    var stk = d.querySelector('.ccx-sticky'); var pm = stk && stk.querySelector('.ccx-sticky__price-m');
    if (pm && o2) pm.textContent = money(o2.price);
  }
  function initSticky() {
    var sticky = d.querySelector('.ccx-sticky'); if (!sticky || !curDir) return;
    var atc = sticky.querySelector('.ccx-btn'), inEl = sticky.querySelector('.ccx-sticky__in'); if (!atc || !inEl) return;
    if (SOLD_OUT[curDir]) {
      var soBtn = atc.cloneNode(true);
      soBtn.textContent = 'Sold out';
      soBtn.setAttribute('disabled', ''); soBtn.setAttribute('aria-disabled', 'true');
      soBtn.classList.add('is-sold-out'); soBtn.style.pointerEvents = 'none'; soBtn.style.opacity = '.55';
      if (soBtn.tagName === 'A') soBtn.removeAttribute('href');
      atc.parentNode.replaceChild(soBtn, atc);
      return;
    }
    var p = CATALOG[curDir];
    inEl.style.position = 'relative';
    var qa = d.createElement('div'); qa.className = 'ccx-qa'; qa.hidden = true;
    var head = p.type === 'variant' ? 'Choose your pack' : 'How many?';
    qa.innerHTML = '<div class="ccx-qa__head">' + head + '</div><div class="ccx-qa__opts">' +
      p.options.map(function (o) { return '<button type="button" class="ccx-qa__opt" data-key="' + o.key + '"><b>' + o.label + '</b><span>' + money(o.price) + '</span></button>'; }).join('') +
      '</div><button type="button" class="ccx-btn ccx-btn--block ccx-qa__add">Add to cart</button>';
    inEl.appendChild(qa); stickyQA = qa;
    var openBtn = d.createElement('button'); openBtn.type = 'button'; openBtn.className = atc.className; openBtn.textContent = 'Add to cart ↑';
    atc.parentNode.replaceChild(openBtn, atc);
    openBtn.addEventListener('click', function (e) { e.preventDefault(); qa.hidden = !qa.hidden; if (!qa.hidden) syncSticky(); });
    qa.addEventListener('click', function (e) {
      var o = e.target.closest('.ccx-qa__opt');
      if (o) { driveSelector(o.getAttribute('data-key')); return; }
      if (e.target.closest('.ccx-qa__add')) {
        var prodForm = d.querySelector('form[action*="/cart/add"]');
        if (prodForm) addFromForm(prodForm);
        qa.hidden = true;
      }
    });
    /* Only a GENUINE user click outside the sticky closes the qty panel. driveSelector()
       programmatically clicks the page's offer option (outside the sticky) to keep the
       selection in sync — that synthetic click (isTrusted=false) must NOT close the panel,
       otherwise selecting a qty collapses the panel and the user has to reopen it. */
    d.addEventListener('click', function (e) { if (e.isTrusted && !qa.hidden && !sticky.contains(e.target)) qa.hidden = true; });
    /* collapsed sticky bar shows a compact price on mobile (where the full __txt span is hidden) */
    var txtEl = sticky.querySelector('.ccx-sticky__txt');
    if (txtEl && !txtEl.querySelector('.ccx-sticky__price-m')) { var pmEl = d.createElement('span'); pmEl.className = 'ccx-sticky__price-m'; txtEl.appendChild(pmEl); }
    syncSticky();
  }

  /* Keep the accelerated-checkout form's quantity in sync with the current selection so the NATIVE
     Shop Pay button checks out the right quantity. Needed for bundle pages and any page using the
     v10 tier selector (whose tiers replace the old quantity radios) — we set/create a single hidden
     [name="quantity"]. Plain qbreaks pages (no v10) still drive quantity via their own radios. */
  function syncFormQty() {
    if (!curDir) return;
    var p = CATALOG[curDir];
    var hasV10 = !!d.querySelector('.v10-opt');
    if (!hasV10 && p.type !== 'bundle') return;
    var acc = d.querySelector('shopify-accelerated-checkout');
    var f = (acc && acc.closest('form')) || d.querySelector('form[action*="/cart/add"]');
    if (!f) return;
    var o = opt(curDir, curKey) || p.options[0];
    var units = (p.type === 'variant') ? 1 : (o ? o.units : 1);
    var qi = f.querySelector('input[name="quantity"]:not([type="radio"])');
    if (!qi) { qi = d.createElement('input'); qi.type = 'hidden'; qi.name = 'quantity'; f.appendChild(qi); }
    qi.value = String(units);
  }

  /* ---- Native Shop Pay: the CSS un-hides Shopify's own <shopify-accelerated-checkout> (Shop Pay)
     wallet button on every in-stock product page — the real thing, so returning Shop customers get
     1-tap checkout with their saved address + card (last-4 shown). It reads the product form's
     variant + quantity at click time; syncFormQty() keeps the quantity correct for bundle products.
     We no longer build a custom "Buy it now" button. Sold-out products (Replacement Filters) get
     NO accelerated button. ---- */
  function initShopPay() {
    if (!curDir) return;
    if (SOLD_OUT[curDir]) {
      var payBtn = d.querySelector('.shopify-payment-button, [data-shopify="payment-button"]');
      if (payBtn) payBtn.style.setProperty('display', 'none', 'important');
      var acc = d.querySelector('shopify-accelerated-checkout');
      if (acc) acc.style.setProperty('display', 'none', 'important');
      return;
    }
    syncFormQty();
    matchShopPayToAtc();
  }

  /* Make the native Shop Pay wallet button visually match the Add-to-Cart button: same pill
     corner radius + same height. The wallet paints in a closed shadow tree we can't reach, so
     we drive it through Shopify's documented CSS custom properties on <shopify-accelerated-checkout>,
     reading the ACTUAL Add-to-Cart radius/height on this page so it matches exactly everywhere. */
  function matchShopPayToAtc() {
    if (!curDir || SOLD_OUT[curDir]) return;
    var acc = d.querySelector('shopify-accelerated-checkout'); if (!acc) return;
    var atc = d.querySelector('.product-form__submit') || d.querySelector('form[action*="/cart/add"] button[name="add"]'); if (!atc) return;
    var acs = getComputedStyle(atc);
    var h = Math.round(atc.getBoundingClientRect().height);
    if (acs.borderTopLeftRadius) acc.style.setProperty('--shopify-accelerated-checkout-button-border-radius', acs.borderTopLeftRadius);
    if (h > 20) acc.style.setProperty('--shopify-accelerated-checkout-button-block-size', h + 'px');
  }

  /* ---- Buy-with-Shop click → show a simple loading wheel over the button while Shop Pay opens
     the checkout. Cleared on back-navigation (pageshow/bfcache), when the tab regains visibility,
     and by a safety timeout — so it can never be left spinning. The wallet paints in a closed
     shadow tree, but the click event is composed and retargets to the <shop-pay-wallet-button>
     host, so a capture-phase document listener reliably catches it. ---- */
  function showShopPaySpinner() {
    var payDiv = d.querySelector('.shopify-payment-button');
    var wb = d.querySelector('shop-pay-wallet-button');
    if (!payDiv || !wb || payDiv.querySelector('.cc-sp-load')) return;
    var pr = payDiv.getBoundingClientRect(), wr = wb.getBoundingClientRect();
    var radius = '22px', atc = d.querySelector('.product-form__submit');
    if (atc) { var rr = getComputedStyle(atc).borderTopLeftRadius; if (rr) radius = rr; }
    payDiv.style.position = 'relative';
    var ov = d.createElement('div');
    ov.className = 'cc-sp-load';
    ov.style.cssText = 'position:absolute;left:0;right:0;top:' + Math.max(0, Math.round(wr.top - pr.top)) + 'px;height:' + Math.round(wr.height) + 'px;border-radius:' + radius + ';';
    ov.innerHTML = '<span class="cc-sp-wheel" aria-hidden="true"></span>';
    payDiv.appendChild(ov);
    setTimeout(hideShopPaySpinner, 15000);
  }
  function hideShopPaySpinner() {
    d.querySelectorAll('.cc-sp-load').forEach(function (o) { o.remove(); });
  }
  d.addEventListener('click', function (e) {
    if (!curDir || SOLD_OUT[curDir]) return;
    if (e.target && e.target.closest && e.target.closest('shop-pay-wallet-button')) showShopPaySpinner();
  }, true);
  d.addEventListener('visibilitychange', function () { if (!d.hidden) hideShopPaySpinner(); });

  /* Reset loading states whenever the page is shown — including a back-navigation restore from
     the browser's bfcache, where the Add-to-Cart / Buy-with-Shop loaders would otherwise stay
     stuck. */
  window.addEventListener('pageshow', function () {
    setAtcLoading(false);
    hideShopPaySpinner();
  });

  /* ---- Full-page /cart review page (static clone renders no real cart, so build one) ----
     Line-item thumbnails use the correct current product imagery (mapped by handle to the
     up-to-date theme assets) rather than the stale image on the Shopify variant record. */
  var CDN = 'https://cdn.shopify.com/s/files/1/0957/0847/9772';
  /* the FIRST gallery image shown on each product page — used for cart line-item thumbnails
     so the cart/drawer imagery matches the product page (the Shopify variant image is stale). */
  var CART_IMG = {
    'full-seat-cover': '/t/4/assets/petride-full-seat-cover-hero-v3.png',
    'single-seat-cover': '/t/4/assets/petride-single-seat-cover-1-v2.png',
    'steady-ride-system': '/files/swap-swap-petride-steady-ride-system-1-v3.webp?v=1783308443',
    'travel-bed': '/t/4/assets/petride-travel-bed-checkered.png',
    'pet-water-fountain': '/t/4/assets/petride-pwf-1-v3.png',
    'replacement-filters': '/t/4/assets/petride-replacement-filters-1-v3.png'
  };
  /* Serve cart thumbnails RESIZED via the Shopify CDN (?width=) — the raw hero PNGs are ~2MB and
     time out on flaky mobile connections (the "broken image / blue ?" bug). 200-300px is plenty. */
  function sized(u, w) { return u ? (u + (u.indexOf('?') > -1 ? '&' : '?') + 'width=' + (w || 300)) : u; }
  /* Cart thumbnail = the product's HERO image as set in Shopify admin (its featured image), NOT the
     theme-asset page image. /cart.js gives us that directly as it.featured_image.url. */
  function cartImg(it) { var u = (it.featured_image && it.featured_image.url) || it.image || (it.handle && CART_IMG[it.handle] ? CDN + CART_IMG[it.handle] : '') || ''; return sized(u, 200); }
  function cartPageRow(it) {
    var price = (it.final_line_price != null ? it.final_line_price : it.line_price) / 100;
    var o = (it.variant_title && it.variant_title !== 'Default Title') ? it.variant_title : '';
    return '<div class="cc-cp__row" data-key="' + it.key + '">' +
      '<a href="' + (it.url || '#') + '" class="cc-cp__imgwrap"><img src="' + cartImg(it) + '" alt=""></a>' +
      '<div class="cc-cp__meta"><a class="cc-cp__title" href="' + (it.url || '#') + '">' + (it.product_title || it.title) + '</a>' +
      (o ? '<div class="cc-cp__opt">' + o + '</div>' : '') +
      '<div class="cc-cp__qty"><button type="button" data-cpstep="-1" aria-label="Decrease">&minus;</button><span>' + it.quantity + '</span><button type="button" data-cpstep="1" aria-label="Increase">+</button>' +
      '<button type="button" class="cc-cp__rm" data-cprm>Remove</button></div></div>' +
      '<div class="cc-cp__price">' + money(price) + '</div></div>';
  }
  var nativeCartExpress = null, nativeCartTerms = null, cartShellBuilt = false;
  function renderCartPage() {
    if (location.pathname.replace(/\/$/, '') !== '/cart') return;
    var main = d.querySelector('#MainContent') || d.querySelector('main'); if (!main) return;
    /* Preserve the native express-checkout wallets (Shop Pay / PayPal) + Afterpay terms BEFORE the
       custom cart wipes #MainContent, so we can re-home them into the order summary below. */
    try {
      if (!nativeCartExpress) { var _ex = d.querySelector('.cart__dynamic-checkout-buttons'); if (_ex && _ex.parentNode) { _ex.parentNode.removeChild(_ex); nativeCartExpress = _ex; } }
      if (!nativeCartTerms) { var _tm = d.querySelector('.cc-cart-payment-terms'); if (_tm && _tm.parentNode) { _tm.parentNode.removeChild(_tm); nativeCartTerms = _tm; } }
    } catch (e) {}
    var host = d.querySelector('#cc-cartpage');
    if (!host) { host = d.createElement('div'); host.id = 'cc-cartpage'; main.innerHTML = ''; main.appendChild(host); cartShellBuilt = false; }
    var items = (shopifyCart && shopifyCart.items) || [];
    var sub = shopifyCart ? (shopifyCart.items_subtotal_price != null ? shopifyCart.items_subtotal_price : shopifyCart.total_price) / 100 : 0;
    if (!items.length) { host.innerHTML = '<div class="cc-cp__empty"><h1>Your cart is empty</h1><a class="ccx-btn ccx-btn--block" href="/pages/shop">Shop all PetRide</a></div>'; cartShellBuilt = false; return; }
    /* Build the page shell ONCE. Rebuilding it on every cart change would re-append the native
       <shopify-accelerated-checkout-cart>, re-firing its hydration and rendering a SECOND PayPal
       iframe (the "two PayPals" bug). So build once, then only refresh the item rows + subtotal. */
    if (!cartShellBuilt || !host.querySelector('.cc-cp__grid')) {
      host.innerHTML = '<div class="cc-cp"><h1 class="cc-cp__h">Your cart</h1><div class="cc-cp__grid">' +
        '<div class="cc-cp__items">' +
        '<div id="cc-cp-items"></div>' +
        '<a class="cc-cp__cont" href="/pages/shop">&larr; Continue shopping</a>' +
        '<div class="cc-cp__ship"><label for="cc-cp-zip">Estimate shipping</label>' +
        '<div class="cc-cp__shiprow"><input id="cc-cp-zip" inputmode="numeric" maxlength="4" placeholder="Postcode"><button id="cc-cp-estimate" type="button">Estimate</button></div>' +
        '<div id="cc-cp-rates" class="cc-cp__rates"></div></div>' +
        '</div>' +
        '<aside class="cc-cp__summary"><h2>Order summary</h2>' +
        '<div class="cc-cp__line"><span>Subtotal</span><b id="cc-cp-subtotal">' + money(sub) + '</b></div>' +
        '<button id="cc-cp-checkout" name="checkout" type="button" class="cc-cp__checkout ccx-btn ccx-btn--block">Checkout</button>' +
        '<div id="cc-cp-express" class="cc-cp__express"></div>' +
        '<div id="cc-cp-afterpay" class="cc-cp__afterpay"></div>' +
        '<a class="cc-cp__shopmore" href="/pages/shop">Shop more</a>' +
        '<p class="cc-cp__note">Shipping &amp; taxes calculated at checkout.</p></aside>' +
        '</div></div>';
      /* re-home the preserved native wallets + Afterpay terms ONCE (never re-appended after this) */
      try {
        if (nativeCartExpress) {
          var _phe = host.querySelector('#cc-cp-express');
          if (_phe) {
            _phe.appendChild(nativeCartExpress);
            (function (el) {
              setTimeout(function () {
                try {
                  var skel = el.querySelector('.wallet-cart-grid--skeleton');
                  var real = el.querySelector('shop-pay-wallet-button, iframe, .wallet-cart-button:not(.wallet-cart-button__skeleton)');
                  if (skel && !real) el.style.display = 'none';
                } catch (e) {}
              }, 8000);
            })(_phe);
          }
        }
        if (nativeCartTerms) { var _pha = host.querySelector('#cc-cp-afterpay'); if (_pha) { _pha.appendChild(nativeCartTerms); _pha.style.display = (nativeCartTerms.querySelector('*') || (nativeCartTerms.textContent || '').trim()) ? '' : 'none'; } }
      } catch (e) {}
      cartShellBuilt = true;
    }
    /* refresh only the dynamic bits every render — this NEVER touches the wallet element */
    var itemsEl = host.querySelector('#cc-cp-items'); if (itemsEl) itemsEl.innerHTML = items.map(cartPageRow).join('');
    var subEl = host.querySelector('#cc-cp-subtotal'); if (subEl) subEl.textContent = money(sub);
  }
  function estimateShipping() {
    var zip = (d.getElementById('cc-cp-zip') || {}).value || '';
    var out = d.getElementById('cc-cp-rates'); if (!out) return;
    out.innerHTML = '<div class="cc-cp__rate">Checking…</div>';
    fetch('/cart/shipping_rates.json?shipping_address%5Bzip%5D=' + encodeURIComponent(zip) + '&shipping_address%5Bcountry%5D=Australia&shipping_address%5Bprovince%5D=', { headers: { 'Accept': 'application/json' } })
      .then(function (r) { return r.json(); })
      .then(function (data) {
        var rates = (data && data.shipping_rates) || [];
        if (!rates.length) { out.innerHTML = '<div class="cc-cp__rate">Final shipping shown at checkout.</div>'; return; }
        out.innerHTML = rates.map(function (rt) { var p = parseFloat(rt.price); return '<div class="cc-cp__rate"><span>' + rt.name + '</span><b>' + (p === 0 ? 'Free' : money(p)) + '</b></div>'; }).join('');
      })
      .catch(function () { out.innerHTML = '<div class="cc-cp__rate">Enter a postcode — final shipping shown at checkout.</div>'; });
  }
  /* cart-page interactions (qty / remove / estimate) drive the real cart */
  d.addEventListener('click', function (e) {
    var host = d.querySelector('#cc-cartpage'); if (!host || !host.contains(e.target)) return;
    var step = e.target.closest('[data-cpstep]'), rm = e.target.closest('[data-cprm]');
    if (rm) { var r = rm.closest('.cc-cp__row'); if (r) changeLine(r.getAttribute('data-key'), 0); return; }
    if (step) { var r2 = step.closest('.cc-cp__row'); if (r2) { var ln = lineByKey(r2.getAttribute('data-key')); if (ln) changeLine(ln.key, Math.max(0, ln.quantity + parseInt(step.getAttribute('data-cpstep'), 10))); } return; }
    if (e.target.closest('#cc-cp-estimate')) { estimateShipping(); return; }
  });

  /* ---- mobile only: sit the trust/shipping strip directly below Buy It Now.
     Desktop/tablet are untouched — the ORIGINAL strip stays exactly where it is and a
     CLONE (.cc-shipping-note--m) is placed in the button column; CSS media queries decide
     which one is visible, so there is no reflow/flicker and nothing else is disturbed. ---- */
  function placeMobileShipNote() {
    var wrap = d.querySelector('.product-form__buttons');
    if (!wrap) return;
    /* anchor the mobile trust/payment strip to the native Shop Pay button (was the old .cc-buynow) */
    var bn = wrap.querySelector('.shopify-payment-button') || wrap.querySelector('[data-shopify="payment-button"]') || wrap.querySelector('.cc-buynow');
    if (!bn) return;
    var clone = d.querySelector('.cc-shipping-note--m');
    if (!clone) {
      var orig = d.querySelector('.cc-shipping-note:not(.cc-shipping-note--m)');
      if (!orig) return;
      clone = orig.cloneNode(true);
      clone.classList.add('cc-shipping-note--m');
      clone.classList.remove('small-hide', 'medium-hide', 'large-up-hide'); /* let our CSS control visibility */
      /* animation: start in the pre-animation (clipped) state and only PLAY once the strip
         actually scrolls into view — same behaviour as the desktop originals. Previously we
         force-added --play here, which made the truck actuate before it was in view on mobile. */
      clone.classList.remove('cc-ship-anim--play');
      clone.classList.add('cc-ship-anim');
      if ('IntersectionObserver' in window) {
        var cio = new IntersectionObserver(function (es) {
          es.forEach(function (e) { if (e.isIntersecting) { e.target.classList.add('cc-ship-anim--play'); cio.unobserve(e.target); } });
        }, { threshold: 0.45 });
        cio.observe(clone);
      } else {
        clone.classList.add('cc-ship-anim--play');
      }
    }
    /* Mobile target order below Buy It Now: PAYMENT options -> animated Fast Dispatch strip.
       To be identical on every template (some flex-reorder the product-info column), on mobile we
       relocate BOTH the payment block and this clone INTO the button column right after Buy It Now.
       On desktop the payment block is restored to its original spot; the clone is CSS-hidden. */
    var payment = d.querySelector('.payment-badges-block');
    if (payment && !payment.__ccHome) {
      var ph = d.createComment('cc-payment-home');
      payment.parentNode.insertBefore(ph, payment);
      payment.__ccHome = ph;
    }
    if (window.matchMedia('(max-width: 749px)').matches) {
      if (payment && bn.nextElementSibling !== payment) bn.insertAdjacentElement('afterend', payment);
      var after = payment || bn;
      if (after.nextElementSibling !== clone) after.insertAdjacentElement('afterend', clone);
    } else {
      if (payment && payment.__ccHome && payment.__ccHome.parentNode) payment.__ccHome.parentNode.insertBefore(payment, payment.__ccHome.nextSibling);
      if (bn.nextElementSibling !== clone) bn.insertAdjacentElement('afterend', clone);
    }
  }

  /* ---- boot ---- */
  function boot() {
    /* The full /cart page is removed — the fold-in drawer is the only cart step. If someone lands on
       /cart (bookmark, typed URL, stray link), bounce them home and open the drawer instead. */
    if (location.pathname.replace(/\/$/, '') === '/cart') { try { sessionStorage.setItem('cc-open-drawer', '1'); } catch (e) {} location.replace('/'); return; }
    refreshCart(false).then(function () {
      renderCartPage();
      try { if (sessionStorage.getItem('cc-open-drawer')) { sessionStorage.removeItem('cc-open-drawer'); openDrawer(); } } catch (e) {}
    });
    if (curDir) { readSelection(); initSticky(); initShopPay(); placeMobileShipNote(); v10RevealOpen(); }
  }
  if (d.readyState === 'loading') d.addEventListener('DOMContentLoaded', boot); else boot();
  window.addEventListener('load', placeMobileShipNote);
  window.addEventListener('load', matchShopPayToAtc);
  try { window.matchMedia('(max-width: 749px)').addEventListener('change', placeMobileShipNote); } catch (e) {}
  try { window.matchMedia('(max-width: 749px)').addEventListener('change', matchShopPayToAtc); } catch (e) {}
})();

/* ============================================================
   PetRide — fix-brief items 1,2,3,10,11 (appended)
   ============================================================ */
(function () {
  'use strict';
  var d = document;
  function ready(fn) { if (d.readyState === 'loading') d.addEventListener('DOMContentLoaded', fn); else fn(); }
  ready(function () {

    /* Item 10 — trademark ™ is now baked statically into the HTML (product H1, footer,
       legal pages) as <sup class="tm">™</sup>. The old runtime JS that inserted a ™ after
       "PetRide" is REMOVED — it was double-adding on top of the static ™ (PetRide™™). */

    /* Item 3 — flatten the mobile menu so products show at the top level (no drill-down view) */
    (function () {
      var nav = d.querySelector('.menu-drawer__navigation .menu-drawer__menu');
      if (!nav) return;
      var details = nav.querySelector('li details');
      if (!details) return;
      var li = details.closest('li');
      var links = details.querySelectorAll('a[href]');
      if (!li || !links.length) return;
      /* normalise product links so a handle missing its /products/ prefix (e.g.
         "/single-seat-cover") or a broken "/" self-link becomes the real product URL. */
      var HANDLES = ['full-seat-cover', 'single-seat-cover', 'steady-ride-system', 'travel-bed', 'pet-water-fountain', 'replacement-filters'];
      var BYTEXT = { 'full seat cover': 'full-seat-cover', 'single seat cover': 'single-seat-cover', 'steadyride system': 'steady-ride-system', 'steady ride system': 'steady-ride-system', 'travel bed': 'travel-bed', 'pet water fountain': 'pet-water-fountain', 'replacement filters': 'replacement-filters' };
      function normHref(href, text) {
        var bare = (href || '').replace(/^\/+/, '').replace(/\/+$/, '');
        if (HANDLES.indexOf(bare) !== -1) return '/products/' + bare;
        var key = (text || '').toLowerCase().replace(/\s+/g, ' ').trim();
        if (BYTEXT[key]) return '/products/' + BYTEXT[key];
        return href;
      }
      Array.prototype.forEach.call(links, function (a) {
        var nli = d.createElement('li');
        var na = d.createElement('a');
        na.setAttribute('href', normHref(a.getAttribute('href'), a.textContent));
        na.className = 'menu-drawer__menu-item list-menu__item link link--text focus-inset';
        na.textContent = a.textContent.replace(/\s+/g, ' ').trim();
        nli.appendChild(na);
        li.parentNode.insertBefore(nli, li);
      });
      li.parentNode.removeChild(li);
    })();

    if (!/\/products\//.test(location.pathname)) return;

    var form = d.querySelector('product-form') || d.querySelector('.main-product-form') || d.querySelector('form[action*="/cart/add"]');
    if (!form) return;
    var atcBtn = d.querySelector('.main-product-atc') || d.querySelector('.product-form__submit') || d.querySelector('button[name="add"]') || form;

    /* Item 2 — purple "Shop" button directly below Add to Cart (mobile), above the payment options.
       The ATC sits in .product-form__quantity-and-btn; the payment button is its next sibling, so we
       insert between the two. */
    var atcWrap = (atcBtn.closest && atcBtn.closest('.product-form__quantity-and-btn')) || atcBtn;
    if (!d.querySelector('.cc-shop-btn')) {
      var shop = d.createElement('a');
      shop.className = 'cc-shop-btn';
      shop.setAttribute('href', '/pages/shop');
      shop.textContent = 'Shop all PetRide';
      atcWrap.parentNode.insertBefore(shop, atcWrap.nextSibling);
    }

    /* Item 11 — trust-badge strip below the ATC on mobile (clone; original stays for desktop/tablet),
       sitting just under the Shop button and above the payment options */
    var note = d.querySelector('.cc-shipping-note');
    if (note && !d.querySelector('.cc-shipping-note--m')) {
      var clone = note.cloneNode(true);
      clone.classList.add('cc-shipping-note--m');
      var anchor = d.querySelector('.cc-shop-btn') || atcBtn;
      anchor.parentNode.insertBefore(clone, anchor.nextSibling);
    }
  });
})();


/* ============================================================
   PetRide — product gallery polish
   • tags <media-gallery> as cc-gal-few (<=5 imgs) / cc-gal-many (>5)
   • renders a custom dot bar UNDER the thumbnail strip (desktop),
     proxying to the thumbnail buttons (reliable) and mirroring
     Dawn's aria-current so it tracks the selected image.
   DOM-read + additive only — never moves Dawn's own nodes.
   ============================================================ */
(function () {
  'use strict';
  if (!/\/products\//.test(location.pathname)) return;
  var d = document;
  function polish() {
    var galleries = d.querySelectorAll('media-gallery');
    Array.prototype.forEach.call(galleries, function (g) {
      var mainList = g.querySelector('.product__media-list');
      var count = mainList ? mainList.querySelectorAll('.product__media-item, .slider__slide').length : 0;
      g.classList.remove('cc-gal-few', 'cc-gal-many');
      g.classList.add(count > 5 ? 'cc-gal-many' : 'cc-gal-few');

      if (count > 1 && !g.querySelector('.cc-thumb-dots')) {
        var thumbList = g.querySelector('.thumbnail-list');
        var thumbBtns = thumbList ? [].slice.call(thumbList.querySelectorAll('.thumbnail-list__item .thumbnail, .thumbnail-list__item button')) : [];
        if (thumbBtns.length > 1) {
          var bar = d.createElement('div');
          bar.className = 'cc-thumb-dots';
          thumbBtns.forEach(function (_, i) {
            var b = d.createElement('button');
            b.type = 'button'; b.className = 'cc-thumb-dot';
            b.setAttribute('aria-label', 'Go to image ' + (i + 1));
            bar.appendChild(b);
          });
          g.appendChild(bar);
          var dotEls = [].slice.call(bar.children);
          function setActive(idx) { for (var j = 0; j < dotEls.length; j++) dotEls[j].classList.toggle('is-active', j === idx); }
          dotEls.forEach(function (dot, idx) { dot.addEventListener('click', function () { if (thumbBtns[idx]) thumbBtns[idx].click(); }); });
          function syncFromThumbs() {
            var idx = -1;
            for (var k = 0; k < thumbBtns.length; k++) { if (thumbBtns[k].getAttribute('aria-current') === 'true') { idx = k; break; } }
            setActive(idx < 0 ? 0 : idx);
          }
          syncFromThumbs();
          var mo = new MutationObserver(syncFromThumbs);
          thumbBtns.forEach(function (b) { mo.observe(b, { attributes: true, attributeFilter: ['aria-current'] }); });
        }
      }
    });
  }
  if (d.readyState === 'loading') d.addEventListener('DOMContentLoaded', polish);
  else polish();
  window.addEventListener('load', polish);
})();


/* ============================================================
   PetRide — contact-form THANK-YOU takeover.
   Shopify's {contact} form redirects back with ?contact_posted=true
   on a successful send. On the contact page we then replace the form
   with a full thank-you screen (404-styled). No admin needed.
   ============================================================ */
(function () {
  'use strict';
  try {
    var params = new URLSearchParams(location.search);
    if (params.get('contact_posted') !== 'true') return;
  } catch (e) { return; }
  var d = document;
  function boot() {
    var form = d.getElementById('ContactForm');
    if (!form) return;                       /* only on the contact page */
    if (d.querySelector('.cc-ty')) return;
    var sec = form.closest('section') || form.closest('.shopify-section') || form.parentElement;
    var A = 'https://cdn.shopify.com/s/files/1/0957/0847/9772/t/4/assets/';
    var card = function (href, img, name, price) {
      return '<a class="cc-ty__card" href="' + href + '"><img src="' + A + img + '" alt="' + name + '"><div class="cc-ty__card-b"><b>' + name + '</b><span>' + price + '</span></div></a>';
    };
    var wrap = d.createElement('section');
    wrap.className = 'cc-ty';
    wrap.innerHTML =
      '<div class="cc-ty__wrap">' +
        '<span class="cc-ty__eyebrow">\uD83D\uDC3E Message received</span>' +
        '<h1 class="cc-ty__big">Thanks \u2014 we\u2019re on it.</h1>' +
        '<p class="cc-ty__sub">Your message just landed with the PetRide crew. A real human will get back to you shortly \u2014 usually within one business day. Keep an eye on your inbox (and the spam folder, just in case).</p>' +
        '<div class="cc-ty__ctas">' +
          '<a class="cc-ty__btn cc-ty__btn--primary" href="/pages/shop">Shop all PetRide</a>' +
          '<a class="cc-ty__btn cc-ty__btn--ghost" href="/">Take me home</a>' +
        '</div>' +
        '<div class="cc-ty__pick">While the kettle boils\u2026</div>' +
        '<div class="cc-ty__grid">' +
          card('/products/full-seat-cover', 'petride-full-seat-cover-hero-v3.png', 'Full Seat Cover', '$119.95') +
          card('/products/steady-ride-system', 'petride-steady-ride-system-1-v3.png', 'SteadyRide System', '$179.90') +
          card('/products/pet-water-fountain', 'petride-pwf-1-v3.png', 'Pet Water Fountain', '$129.95') +
        '</div>' +
      '</div>';
    /* full takeover: hide everything else in <main> (intro heading + form) and show only the thank-you */
    var main = (form.closest('main')) || d.querySelector('main');
    if (main) {
      [].forEach.call(main.children, function (ch) { ch.style.display = 'none'; });
      main.appendChild(wrap);
    } else if (sec && sec.parentNode) {
      sec.parentNode.insertBefore(wrap, sec); sec.style.display = 'none';
    } else {
      d.body.insertBefore(wrap, d.body.firstChild);
    }
    try { window.scrollTo(0, 0); } catch (e) {}
  }
  if (d.readyState === 'loading') d.addEventListener('DOMContentLoaded', boot); else boot();
})();


/* ============================================================
   PetRide — swap two nav items ("Why Hard Base" <-> "SteadyRide System")
   in both the mobile menu-drawer and the desktop inline menu, so both
   stay consistent. Static-clone nav is baked into every page, so we do
   this once at runtime instead of editing every page file.
   ============================================================ */
(function () {
  'use strict';
  var d = document;
  function swapPair(root) {
    if (!root || root.getAttribute('data-nav-swapped')) return;
    var why = root.querySelector('a[href="/pages/why-hard-base"]');
    var steady = root.querySelector('a[href="/products/steady-ride-system"]');
    if (!why || !steady) return;
    var a = why.closest('li') || why;
    var b = steady.closest('li') || steady;
    if (!a.parentNode || a.parentNode !== b.parentNode) return; /* must be siblings */
    var parent = a.parentNode;
    var aNext = a.nextSibling;          /* a's original slot marker (captured before moving) */
    parent.insertBefore(a, b);          /* move a (Why Hard Base) to just before b */
    parent.insertBefore(b, aNext);      /* move b (SteadyRide) into a's original slot */
    root.setAttribute('data-nav-swapped', '1');
  }
  function swapNav() {
    swapPair(d.getElementById('menu-drawer'));
    swapPair(d.querySelector('.header__inline-menu'));
  }
  if (d.readyState === 'loading') d.addEventListener('DOMContentLoaded', swapNav); else swapNav();
  window.addEventListener('load', swapNav);
})();

/* ============================================================
   MODULE 7 — SteadyRide bundle pop-up (STEADY10) + floating recall tab.
   One-to-one port of the localhost:5700 "steadypop": bundle framing
   (Full Seat Cover + Travel Bed = SteadyRide System $179.90), email capture
   → reveals STEADY10 → "Take me there" applies the code and lands on the
   SteadyRide product page. "Reveal my 10% code" submits a REAL Shopify newsletter
   form (form_type=customer) top-level to /contact so the shopper is genuinely
   subscribed — Cloudflare blocks background iframe/fetch posts — then Shopify
   returns them here and the popup re-opens straight into the code reveal.
   A persistent "🎁 10% off?" tab (bottom-left, top-most z-index) reopens it
   after it's dismissed. Auto-opens once per session on home + product pages;
   the tab shows on every page. Suppressed for good once the code is grabbed.
   ============================================================ */
(function () {
  if (window.__prSteadyPop) return; window.__prSteadyPop = true;
  return; /* MODULE 7 RETIRED 2026-08-11 — replaced by the new 10%-off welcome popup (snippets/home-popup.liquid + assets/pr-popup.js). Left inert to avoid disturbing surrounding modules. */

  var CODE = 'STEADY10';
  var DEST = '/discount/' + CODE + '?redirect=' + encodeURIComponent('/products/steady-ride-system');
  /* where Shopify returns the shopper after the top-level subscribe round-trip (this page) */
  var RET = (location.pathname || '/').replace(/"/g, '%22');
  /* the two bundle photos — the product images Alex supplied (400x400 for a crisp
     retina tile), with an onerror fall-back to the full-size master so a tile never blanks. */
  var IMG_COVER = 'https://cdn.shopify.com/s/files/1/0957/0847/9772/files/petride-tile-full-seat-cover.webp?v=1793250490';
  var IMG_BED = 'https://cdn.shopify.com/s/files/1/0957/0847/9772/files/petride-tile-travel-bed.webp?v=1793250496';
  var IMG_COVER_FB = 'https://cdn.shopify.com/s/files/1/0957/0847/9772/files/petride-tile-full-seat-cover.webp?v=1793250490';
  var IMG_BED_FB = 'https://cdn.shopify.com/s/files/1/0957/0847/9772/files/petride-tile-travel-bed.webp?v=1793250496';

  function scene() {
    return '' +
    '<div class="sp-scene">' +
      '<div class="sp-backdrop" data-sp-close></div>' +
      '<div class="sp" role="dialog" aria-modal="true" aria-label="A further 10% off the SteadyRide System">' +
        '<button type="button" class="sp-x" data-sp-close aria-label="Close">✕</button>' +
        '<div class="sp-pad">' +
          '<div class="sp-main">' +
            '<div class="sp-head">' +
              '<div class="sp-eyebrow">◆ Bundle &amp; save</div>' +
              '<div class="sp-h">A further 10% off the SteadyRide System</div>' +
            '</div>' +
            '<div class="sp-cols">' +
              '<div class="sp-left">' +
                '<div class="sp-bundle">' +
                  '<div class="sp-prod"><img src="' + IMG_COVER + '" alt="PetRide Full Seat Cover" loading="lazy" onerror="this.onerror=null;this.src=\'' + IMG_COVER_FB + '\'"></div>' +
                  '<span class="sp-op">+</span>' +
                  '<div class="sp-prod"><img src="' + IMG_BED + '" alt="PetRide Custom-Fit Travel Bed" loading="lazy" onerror="this.onerror=null;this.src=\'' + IMG_BED_FB + '\'"></div>' +
                '</div>' +
                '<div class="sp-kit">= The SteadyRide System</div>' +
                '<div class="sp-price">' +
                  '<div class="sp-price-ref"><s>$229.90</s> separately · <b>$179.90</b> bundled</div>' +
                  '<div class="sp-price-now">$161.91 <span>with your code</span></div>' +
                  '<div class="sp-save">You save $67.99 · 30%</div>' +
                '</div>' +
              '</div>' +
              '<div class="sp-right">' +
                '<div class="sp-offer">A further <b>10% off</b>, just for you</div>' +
                '<form class="sp-field" method="post" action="/contact" accept-charset="UTF-8" target="pr_sp_sink" data-sp-form novalidate>' +
                  '<input type="hidden" name="form_type" value="customer">' +
                  '<input type="hidden" name="utf8" value="✓">' +
                  '<input type="hidden" name="contact[tags]" value="newsletter, steadyride-popup">' +
                  '<input type="hidden" name="return_to" value="' + RET + '">' +
                  '<input type="email" name="contact[email]" placeholder="you@email.com" aria-label="Email address" autocomplete="email" inputmode="email" required>' +
                  '<button type="submit" class="sp-btn">Reveal my 10% code</button>' +
                '</form>' +
                /* the newsletter POST lands here (hidden) so the shopper is subscribed
                   server-side without the main page ever navigating — the code reveals instantly */
                '<iframe name="pr_sp_sink" class="sp-sink" title="subscribe" aria-hidden="true" tabindex="-1"></iframe>' +
                '<div class="sp-trust"><span class="stars">★★★★★</span> 4.9 from 1,000+ · Free shipping · 60-day money-back</div>' +
                '<span class="sp-decline" data-sp-close>No thanks, I’ll pay full price</span>' +
              '</div>' +
            '</div>' +
          '</div>' +
          '<div class="sp-reveal">' +
            '<div class="sp-badge2">🎉</div>' +
            '<div class="sp-eyebrow">You’re in, here’s your code</div>' +
            '<div class="sp-h">A further 10% off the SteadyRide System</div>' +
            '<button type="button" class="sp-code" data-sp-copy title="Click to copy"><span class="sp-code-val">' + CODE + '</span><span class="sp-code-hint">Tap to copy</span></button>' +
            '<p class="sp-reveal-sub">Copy the code and apply it at checkout for <b>$161.91</b>, a further 10% off the $179.90 bundle (you save <b>$67.99</b> vs buying the two separately).</p>' +
            '<button type="button" class="sp-checkout" data-sp-checkout>Take me there →</button>' +
          '</div>' +
        '</div>' +
      '</div>' +
    '</div>';
  }

  var modal = document.createElement('div');
  modal.className = 'sp-modal';
  modal.id = 'prSteadyPop';
  modal.setAttribute('aria-hidden', 'true');
  modal.innerHTML = scene();

  var tab = document.createElement('button');
  tab.type = 'button';
  tab.className = 'sp-tab';
  tab.id = 'prSteadyTab';
  tab.setAttribute('data-sp-open', '');
  tab.setAttribute('aria-label', 'Get a further 10% off the SteadyRide System');
  tab.innerHTML = '<span class="sp-tab-ic" aria-hidden="true">🎁</span> 10% off?';

  /* the recall tab stays put until the shopper enters their email. A plain exit
     (✕/backdrop/decline) without an email leaves it in place; once they've subscribed
     (pr_sp_done) it's retired. */
  function tabHidden() { try { return localStorage.getItem('pr_sp_done') === '1'; } catch (e) { return false; } }
  function mount() { document.body.appendChild(modal); document.body.appendChild(tab); if (tabHidden()) tab.style.display = 'none'; }
  if (document.body) mount(); else document.addEventListener('DOMContentLoaded', mount);

  /* gentle nudge: shake the tab every 5s after landing while it's showing (i.e. until they
     enter their email) — keeps nudging even if they open it and leave without subscribing */
  setInterval(function () {
    if (tab && getComputedStyle(tab).display !== 'none') {
      tab.classList.remove('sp-tab--shake'); void tab.offsetWidth; tab.classList.add('sp-tab--shake');
    }
  }, 5000);

  var sceneEl = modal.querySelector('.sp-scene');
  var card = modal.querySelector('.sp');

  function open() {
    modal.classList.add('is-open');
    modal.setAttribute('aria-hidden', 'false');
    document.documentElement.classList.add('sp-noscroll');
    tab.style.display = 'none';
    sceneEl.classList.remove('play'); void sceneEl.offsetWidth; sceneEl.classList.add('play');
    var i = card.querySelector('input[type=email]');
    if (i) setTimeout(function () { try { i.focus(); } catch (e) {} }, 60);
    try { sessionStorage.setItem('pr_sp_seen', '1'); } catch (e) {}
  }
  function close() {
    if (!modal.classList.contains('is-open') || modal.classList.contains('is-closing')) return;
    var finish = function () {
      modal.classList.remove('is-open', 'is-closing');
      modal.setAttribute('aria-hidden', 'true');
      document.documentElement.classList.remove('sp-noscroll');
      tab.style.display = tabHidden() ? 'none' : '';   /* tab persists after a plain exit; stays gone once they've taken the code */
    };
    var reduce = false; try { reduce = matchMedia('(prefers-reduced-motion: reduce)').matches; } catch (e) {}
    if (reduce) { finish(); return; }
    /* play the entrance in reverse, then hide once the card's exit animation ends */
    modal.classList.add('is-closing');
    sceneEl.classList.remove('play');
    var t = setTimeout(finish, 420);
    card.addEventListener('animationend', function h(e) { if (e.target !== card) return; card.removeEventListener('animationend', h); clearTimeout(t); finish(); });
  }

  var CONFETTI = ['#F97316', '#FB923C', '#1E3A8A', '#2563EB', '#16A34A', '#E0A400', '#E11D48', '#8B5CF6', '#FFF1E0'];
  function confetti() {
    var old = card.querySelector('.sp-confetti'); if (old && old.parentNode) old.parentNode.removeChild(old);
    var layer = document.createElement('div'); layer.className = 'sp-confetti'; var html = '';
    for (var i = 0; i < 80; i++) {
      var left = (Math.random() * 100).toFixed(2), c = CONFETTI[i % CONFETTI.length];
      var delay = (Math.random() * 0.7).toFixed(2), dur = (2.4 + Math.random() * 2.1).toFixed(2);
      var w = (5 + Math.random() * 6).toFixed(1), h = (w * (0.4 + Math.random() * 0.55)).toFixed(1);
      var drift = (Math.random() * 180 - 90).toFixed(0), spin = (Math.random() * 1100 - 450).toFixed(0);
      var round = Math.random() < 0.3 ? '50%' : '2px';
      html += '<i style="left:' + left + '%;background:' + c + ';width:' + w + 'px;height:' + h + 'px;border-radius:' + round + ';animation-delay:' + delay + 's;animation-duration:' + dur + 's;--drift:' + drift + 'px;--spin:' + spin + 'deg"></i>';
    }
    layer.innerHTML = html; card.appendChild(layer);
    setTimeout(function () { if (layer.parentNode) layer.parentNode.removeChild(layer); }, 5200);
  }

  function fallbackCopy(text) {
    var ta = document.createElement('textarea'); ta.value = text; ta.setAttribute('readonly', '');
    ta.style.position = 'fixed'; ta.style.top = '-1000px'; ta.style.opacity = '0';
    document.body.appendChild(ta); ta.select(); try { document.execCommand('copy'); } catch (e) {} document.body.removeChild(ta);
  }
  function copyCode(btn) {
    var hint = btn.querySelector('.sp-code-hint');
    function flash() { btn.classList.add('copied'); if (hint) hint.textContent = 'Copied!'; clearTimeout(btn._t); btn._t = setTimeout(function () { btn.classList.remove('copied'); if (hint) hint.textContent = 'Tap to copy'; }, 1800); }
    if (navigator.clipboard && navigator.clipboard.writeText) { navigator.clipboard.writeText(CODE).then(flash, function () { fallbackCopy(CODE); flash(); }); }
    else { fallbackCopy(CODE); flash(); }
  }

  document.addEventListener('click', function (e) {
    if (e.target.closest('[data-sp-open]')) { try { if (localStorage.getItem('pr_sp_done') === '1') card.classList.add('is-done'); } catch (e2) {} open(); return; }
    if (e.target.closest('[data-sp-checkout]')) { window.location.href = DEST; return; }
    var cp = e.target.closest('[data-sp-copy]'); if (cp) { copyCode(cp); return; }
    var dc = e.target.closest('[data-sp-close]'); if (dc && modal.contains(dc)) { close(); return; }
  });
  /* the email field is a REAL Shopify newsletter form, but it posts into a hidden iframe
     (target="pr_sp_sink") so the shopper is genuinely subscribed server-side WITHOUT the
     main page navigating. That lets us reveal the code INSTANTLY — no /contact round-trip,
     no full-page reload (which was the lag). The native form POST carries the page's
     cf_clearance cookie, so it clears Cloudflare where a background fetch/XHR would 403. */
  modal.addEventListener('submit', function (e) {
    var form = e.target.closest('[data-sp-form]'); if (!form) return;
    var input = form.querySelector('input[type=email]'); var val = input ? input.value.trim() : '';
    if (!/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(val)) { e.preventDefault(); if (input) { input.focus(); input.classList.add('err'); } return; }
    /* valid: retire the tab and let the native submit proceed into the hidden iframe (do NOT
       preventDefault) so the subscribe still lands / triggers Shopify's invisible spam check.
       Defer the reveal one tick so the submission fires BEFORE the form is hidden — hiding it
       synchronously can abort the POST in some engines. The reveal is still instant to the eye. */
    try { localStorage.setItem('pr_sp_done', '1'); } catch (e2) {}
    setTimeout(function () { card.classList.add('is-done'); setTimeout(confetti, 40); }, 0);
  });
  modal.addEventListener('keydown', function (e) {
    if (e.key === 'Escape' && modal.classList.contains('is-open')) { close(); }
  });

  /* keep the recall tab clear of the sticky product buy-bar when it slides in */
  function wireTabLift() {
    var bar = document.querySelector('.ccx-sticky');
    if (!bar) return false;
    var sync = function () { tab.classList.toggle('sp-tab--up', bar.classList.contains('is-shown')); };
    new MutationObserver(sync).observe(bar, { attributes: true, attributeFilter: ['class'] });
    sync();
    return true;
  }
  if (!wireTabLift()) { window.addEventListener('load', wireTabLift); setTimeout(wireTabLift, 1800); }

  /* No auto-open on landing — the persistent "🎁 10% off?" tab (bottom-left) is the entry
     point: a subtle nudge the shopper taps to open the popup. Subscribing now reveals the
     code in-place (hidden-iframe POST), so there's no round-trip to re-open from. */
  try { localStorage.removeItem('pr_sp_reveal'); } catch (e) {}   /* retire the old round-trip flag */
})();

/* ============================================================
   MODULE 8 — Travel Bed Colour variant (Black / Checkered).
   Both products now carry a real Shopify Colour option: Black (the
   original variant) + a new Checkered variant priced +$20. The colour
   buttons used to be static decoration (Checkered locked "out of stock").
   This enables Checkered, switches the add-to-cart variant on select, and
   live-updates every price on the page — main price, "was", the save-%
   badge, the Buy 1/2/3 kit tiers (both .v10-opt and .cc-offer-option UIs,
   discount-aware) + the "back in your pocket" save line, and the
   Afterpay ÷4 amount — so the +$20 shows immediately. Checkout then
   charges the real variant price ($199.90 / $129.95) and STEADY10 applies
   to it natively. A guard ensures only THIS product's price nodes change.
   ============================================================ */
(function () {
  'use strict';
  var d = document;
  var CFG = {
    'steady-ride-system': { black: '54222090764572', checkered: '54338987196700', price: 179.90, compare: 319.90 },
    'travel-bed': { black: '54205963239708', checkered: '54338986967324', price: 109.95, compare: 219.90 }
  };
  var DELTA = 20, WAS_DELTA = 40;
  /* kit-tier discounts: Buy 2 = 10% off, Buy 3 = 20% off (same on both variant products) */
  var TIER_DISC = { '1': 0, '2': 0.10, '3': 0.20 };
  function round2(n) { return Math.round(n * 100) / 100; }
  var handle = (location.pathname.match(/\/products\/([^\/?#]+)/) || [])[1];
  var cfg = handle && CFG[handle];
  if (!cfg) return;
  var root = d.querySelector('.cc-colour');
  if (!root) return;

  function money(n) { return '$' + n.toFixed(2).replace(/\B(?=(\d{3})+(?!\d))/g, ','); }
  var pBase = money(cfg.price), pChk = money(cfg.price + DELTA);

  /* enable the Checkered option (drop the out-of-stock lock) */
  var chkBtn = root.querySelector('.cc-colour__opt[data-cc-colour="Checkered"]');
  if (chkBtn) {
    chkBtn.classList.remove('is-oos'); chkBtn.disabled = false; chkBtn.removeAttribute('aria-disabled');
    var oos = chkBtn.querySelector('.cc-colour__oos'); if (oos && oos.parentNode) oos.parentNode.removeChild(oos);
  }

  function apply(colour) {
    var isChk = colour === 'checkered';
    var price = cfg.price + (isChk ? DELTA : 0);
    var comp = cfg.compare + (isChk ? WAS_DELTA : 0);
    var pct = Math.round((comp - price) / comp * 100);
    var vid = isChk ? cfg.checkered : cfg.black;

    /* 1. switch the add-to-cart variant (only forms already on one of our two variants) */
    [].forEach.call(d.querySelectorAll('form[action*="/cart/add"] input[name="id"]'), function (i) {
      if (i.value === cfg.black || i.value === cfg.checkered) i.value = vid;
    });

    /* 2. the main product price block(s) — guarded to blocks that currently show our price */
    [].forEach.call(d.querySelectorAll('.price'), function (pc) {
      var items = pc.querySelectorAll('.price-item--sale, .price__regular .price-item--regular');
      var isMain = [].some.call(items, function (el) { var t = el.textContent.trim(); return t === pBase || t === pChk; });
      if (!isMain) return;
      [].forEach.call(pc.querySelectorAll('.price__regular .price-item, .price__sale > .price-item--sale'), function (el) { el.textContent = money(price); });
      [].forEach.call(pc.querySelectorAll('.price__compare-price s'), function (el) { el.textContent = money(comp); });
      [].forEach.call(pc.querySelectorAll('.badge__percentage-saved'), function (el) { el.textContent = String(pct); });
    });

    /* 3. the Buy 1/2/3 kit tiers. Supports BOTH tier UIs across the two variant products:
       .v10-opt (SteadyRide) and .cc-offer-option (Travel Bed). Each tier is computed from the
       single-unit price with the tier discount applied to the WHOLE quantity, so the +$20
       Checkered uplift is discounted too (Buy 2 = single×2×0.9, Buy 3 = single×3×0.8) — NOT a
       flat +$20/unit (which mis-priced Buy 2/3 by $4/$12). "was" = single compare-at × qty. */
    [].forEach.call(d.querySelectorAll('.v10-opt, .cc-offer-option'), function (t) {
      var q = t.getAttribute('data-qty'), disc = TIER_DISC[q]; if (disc == null) return;
      var qn = parseInt(q, 10);
      var tNow = round2(price * qn * (1 - disc));
      var tWas = round2(comp * qn);
      var tSave = round2(tWas - tNow);
      t.setAttribute('data-now', tNow.toFixed(2));
      t.setAttribute('data-save', money(tSave));
      var vn = t.querySelector('.v10-now'); if (vn) vn.textContent = money(tNow);
      var vw = t.querySelector('.v10-was'); if (vw) vw.textContent = money(tWas);
      var cp = t.querySelector('.cc-offer-price');
      if (cp) { var st = cp.querySelector('strong'); if (st) st.textContent = money(tNow); var se = cp.querySelector('s'); if (se) se.textContent = money(tWas); }
    });
    /* keep the "back in your pocket" save line synced to the active tier (also fixes its stale load value) */
    var actTier = d.querySelector('.cc-offer-option.is-active') || d.querySelector('.v10-opt[aria-checked="true"]');
    var saveLine = d.querySelector('[data-save-line]');
    if (actTier && saveLine) { var sv = actTier.getAttribute('data-save'); if (sv) saveLine.textContent = "That's " + sv + ' back in your pocket today 🎉'; }

    /* 4. Afterpay ÷4 — update the amount and force the on-site widget to re-render
       (Square/Afterpay placements render once; re-inserting a fresh node re-runs it) */
    var apNew = price.toFixed(2), apOurs = [cfg.price.toFixed(2), (cfg.price + DELTA).toFixed(2)];
    [].forEach.call(d.querySelectorAll('[data-amount]'), function (a) {
      var cv = a.getAttribute('data-amount');
      if (apOurs.indexOf(cv) === -1 || cv === apNew) return;
      a.setAttribute('data-amount', apNew);
      if ((a.tagName || '').toLowerCase() === 'square-placement' && a.parentNode) a.parentNode.replaceChild(a.cloneNode(true), a);
    });

    /* 5. active state on the buttons */
    [].forEach.call(root.querySelectorAll('.cc-colour__opt'), function (b) {
      var on = (b.getAttribute('data-cc-colour') || '').toLowerCase() === colour;
      b.classList.toggle('is-active', on); b.setAttribute('aria-pressed', on ? 'true' : 'false');
    });
  }

  root.addEventListener('click', function (e) {
    var b = e.target.closest && e.target.closest('.cc-colour__opt'); if (!b || b.disabled) return;
    apply((b.getAttribute('data-cc-colour') || '').toLowerCase());
  });

  apply('black');  /* normalise on load (also corrects the stale save-badge %) */
})();

/* ============================================================
   MODULE 9 — CRO navigation drawer (the localhost:5700 "Full CRO stack" nav).
   Replaces the flat Dawn menu list inside #menu-drawer with a conversion-led
   drawer: an always-free free-shipping bar, search, a featured product, categories
   with an in-drawer slide drill-down, best-sellers, 4.9★ proof, trust badges,
   account + support links, and a kept "Why a hard base?" link. Reuses Module 1's
   open/close controller — we only swap the content. Prices + product imagery are
   pulled LIVE from /products/<handle>.js so nothing goes stale; the free-ship bar
   reads the real /cart.js on every open. Mobile/tablet only (≤989px); desktop
   keeps the inline menu. Dropped vs the mock-up: discount code, wishlist, live
   chat, FAQs (no such page). "Shop all" → /pages/shop (no category collections yet).
   ============================================================ */
(function () {
  'use strict';
  if (window.__prNav) return; window.__prNav = true;
  var d = document;
  var AUS = '';
  var SHOP = '/pages/shop';
  var P = {
    'full-seat-cover': 'Full Seat Cover',
    'single-seat-cover': 'Single Seat Cover',
    'travel-bed': 'Travel Bed',
    'steady-ride-system': 'SteadyRide System',
    'pet-water-fountain': 'Pet Water Fountain',
    'replacement-filters': 'Replacement Filters'
  };
  function purl(h) { return '/products/' + h; }
  var CATS = [
    { key: 'seat-covers', label: 'Seat Covers', emoji: '🐕', items: ['full-seat-cover', 'single-seat-cover', 'steady-ride-system'] },
    { key: 'travel-beds', label: 'Travel Beds', emoji: '🛏️', href: purl('travel-bed') },
    { key: 'fountains', label: 'Fountains', emoji: '⛲', items: ['pet-water-fountain', 'replacement-filters'] }
  ];
  var FEATURED = 'steady-ride-system';
  var BEST = ['full-seat-cover', 'travel-bed', 'steady-ride-system'];

  function money(cents) { return '$' + (cents / 100).toFixed(2).replace(/\B(?=(\d{3})+(?!\d))/g, ','); }
  function esc(s) { return String(s).replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/>/g, '&gt;'); }

  function rootHtml() {
    var h = '';
    /* Free shipping on ALL orders (no threshold): a static green "always free" reassurance bar. */
    h += '<div class="prnav-fs is-won" id="prnavFs">' +
           '<div class="prnav-fs__top"><span class="prnav-fs__lbl">🚚 <b>Free shipping</b> on all orders</span><span class="prnav-fs__goal">✓</span></div>' +
           '<div class="prnav-fs__track"><div class="prnav-fs__fill"></div></div>' +
           '<div class="prnav-fs__foot">No minimum, ever &mdash; delivery&rsquo;s on us, Australia-wide.</div>' +
         '</div>';
    /* search */
    h += '<form class="prnav-search" action="/search" method="get" role="search">' +
           '<input type="search" name="q" placeholder="Search products…" aria-label="Search" autocomplete="off">' +
           '<button type="submit">Go</button>' +
         '</form>';
    /* Most popular — heading ABOVE the card; img + name + orange price · save + orange "Shop now" button */
    h += '<div class="prnav-sec"><div class="prnav-h">Most popular</div>' +
           '<a class="prnav-feat" href="' + purl(FEATURED) + '">' +
             '<img class="prnav-feat__img" data-img-for="' + FEATURED + '" alt="SteadyRide System" loading="lazy">' +
             '<span class="prnav-feat__i">' +
               '<b>SteadyRide System</b>' +
               '<span class="prnav-feat__pr" data-price-for="' + FEATURED + '"><em>$319.90</em></span>' +
               '<span class="prnav-fbtn">Shop now</span>' +
             '</span>' +
           '</a></div>';
    /* Shop categories */
    h += '<div class="prnav-sec"><div class="prnav-h">Shop</div><div class="prnav-cats">';
    h += '<a class="prnav-row" href="/"><span class="prnav-row__ic">🏠</span><span class="prnav-row__t">Home</span><span class="prnav-row__x">›</span></a>';
    CATS.forEach(function (c) {
      if (c.href) h += '<a class="prnav-row" href="' + c.href + '"><span class="prnav-row__ic">' + c.emoji + '</span><span class="prnav-row__t">' + c.label + '</span><span class="prnav-row__x">›</span></a>';
      else h += '<button type="button" class="prnav-row" data-drill="' + c.key + '"><span class="prnav-row__ic">' + c.emoji + '</span><span class="prnav-row__t">' + c.label + '</span><span class="prnav-row__x">›</span></button>';
    });
    h += '<a class="prnav-row" href="/pages/why-hard-base"><span class="prnav-row__ic">🦴</span><span class="prnav-row__t">Why a hard base?</span><span class="prnav-row__x">›</span></a>';
    h += '</div></div>';
    /* Best-sellers — rank + img + name + green price (no struck compare, mock-up-exact) */
    h += '<div class="prnav-sec"><div class="prnav-h">Best-sellers</div><div class="prnav-best">';
    BEST.forEach(function (hd, i) {
      h += '<a class="prnav-best__row" href="' + purl(hd) + '"><span class="prnav-best__rank">' + (i + 1) + '</span>' +
             '<img class="prnav-best__img" data-img-for="' + hd + '" alt="' + esc(P[hd]) + '" loading="lazy">' +
             '<span class="prnav-best__i"><b>' + esc(P[hd]) + '</b><span data-price-for="' + hd + '"></span></span></a>';
    });
    h += '</div></div>';
    /* social proof */
    h += '<div class="prnav-social"><span class="prnav-social__stars">★★★★★</span><b>4.9</b><span>from 1,000+ Aussie dog owners</span></div>';
    /* trust badges */
    h += '<div class="prnav-trust">' +
           '<span class="prnav-tb">' + AUS + ' Aussie owned</span>' +
           '<span class="prnav-tb">🛡️ 60-day guarantee</span>' +
           '<span class="prnav-tb">🚚 Free shipping</span>' +
         '</div>';
    /* account */
    h += '<div class="prnav-sec"><div class="prnav-h">Your account</div><div class="prnav-mini">' +
           '<a class="prnav-mrow" href="/account"><span class="prnav-mrow__ic">👤</span>Log in<span class="prnav-mrow__x">›</span></a>' +
           '<a class="prnav-mrow" href="/account/register"><span class="prnav-mrow__ic">✨</span>Create account<span class="prnav-mrow__x">›</span></a>' +
           '<a class="prnav-mrow" href="/pages/order-tracking"><span class="prnav-mrow__ic">📦</span>Track my order<span class="prnav-mrow__x">›</span></a>' +
         '</div></div>';
    /* support */
    h += '<div class="prnav-sec"><div class="prnav-h">Help &amp; support</div><div class="prnav-mini">' +
           '<a class="prnav-mrow" href="/pages/refund-policy"><span class="prnav-mrow__ic">↩️</span>Returns &amp; 60-day guarantee<span class="prnav-mrow__x">›</span></a>' +
           '<a class="prnav-mrow" href="/pages/contact"><span class="prnav-mrow__ic">💬</span>Contact us<span class="prnav-mrow__x">›</span></a>' +
         '</div></div>';
    return h;
  }

  function subHtml(cat) {
    var h = '<button type="button" class="prnav-back" data-up><span class="prnav-back__ic">‹</span>' + esc(cat.label) + '</button><div class="prnav-sub">';
    cat.items.forEach(function (hd) {
      h += '<a class="prnav-row" href="' + purl(hd) + '"><span class="prnav-row__t">' + esc(P[hd]) + '</span><span class="prnav-row__x">›</span></a>';
    });
    h += '<a class="prnav-row prnav-row--all" href="' + SHOP + '"><span class="prnav-row__t">Shop all ' + esc(cat.label) + '</span><span class="prnav-row__x">→</span></a></div>';
    return h;
  }

  var track = null, depth = 0;

  function build() {
    var nav = d.querySelector('#menu-drawer .menu-drawer__navigation-container');
    if (!nav) return false;
    if (nav.getAttribute('data-prnav')) return true;
    nav.setAttribute('data-prnav', '1');
    nav.classList.add('prnav-host');
    nav.innerHTML =
      '<div class="prnav-levels"><div class="prnav-track">' +
        '<div class="prnav-level"><div class="prnav-lscroll">' + rootHtml() + '</div></div>' +
      '</div></div>' +
      '<div class="prnav-foot"><a class="prnav-cta" href="' + SHOP + '">Shop best-sellers</a></div>';
    track = nav.querySelector('.prnav-track');
    fetchPrices();
    return true;
  }

  function slide() { if (track) track.style.transform = 'translateX(-' + (depth * 100) + '%)'; }
  function drill(key) {
    if (!track) return;
    var cat = CATS.filter(function (c) { return c.key === key; })[0];
    if (!cat || !cat.items) return;
    var lvl = d.createElement('div');
    lvl.className = 'prnav-level';
    lvl.innerHTML = '<div class="prnav-lscroll">' + subHtml(cat) + '</div>';
    track.appendChild(lvl);
    depth++; slide();
  }
  function up() {
    if (!track || depth <= 0) return;
    depth--; slide();
    setTimeout(function () { if (track && track.children.length > depth + 1) track.removeChild(track.lastChild); }, 360);
  }
  function reset() {
    if (!track) return;
    depth = 0; slide();
    setTimeout(function () { if (!track) return; while (track.children.length > 1) track.removeChild(track.lastChild); }, 360);
  }

  function fetchPrices() {
    var seen = {};
    [FEATURED].concat(BEST).forEach(function (h) {
      if (seen[h]) return; seen[h] = 1;
      fetch(purl(h) + '.js', { headers: { 'Accept': 'application/json' } })
        .then(function (r) { return r.ok ? r.json() : null; })
        .then(function (p) { if (p) fillProduct(h, p); })
        .catch(function () {});
    });
  }
  function fillProduct(h, p) {
    var price = p.price, comp = p.compare_at_price || 0;
    [].forEach.call(d.querySelectorAll('[data-price-for="' + h + '"]'), function (el) {
      if (el.classList.contains('prnav-feat__pr')) {
        /* orange price + " · save $X" (mock-up format), live compare-at value */
        el.innerHTML = '<em>' + money(price) + '</em>' + (comp > price ? ' · save ' + money(comp - price) : '');
      } else {
        el.textContent = money(price);   /* best-seller: green price only */
      }
    });
    var img = p.featured_image || (p.images && p.images[0]);
    if (img) {
      var src = img.indexOf('//') === 0 ? 'https:' + img : img;
      src += (src.indexOf('?') === -1 ? '?' : '&') + 'width=200';
      [].forEach.call(d.querySelectorAll('[data-img-for="' + h + '"]'), function (im) {
        if (im.tagName === 'IMG') im.src = src; else im.style.backgroundImage = 'url("' + src + '")';
      });
    }
  }

  function refreshFs() {
    var el = d.getElementById('prnavFs'); if (!el) return;
    /* Free shipping on all orders — always the unlocked/won state (no threshold, no countdown). */
    var track = el.querySelector('.prnav-fs__track');
    if (track) track.style.background = 'linear-gradient(90deg,#22c55e 0%,#16a34a 100%)';
    var lbl = el.querySelector('.prnav-fs__lbl'), goalEl = el.querySelector('.prnav-fs__goal');
    if (lbl) lbl.innerHTML = '🚚 <b>Free shipping</b> on all orders';
    if (goalEl) goalEl.textContent = '✓';
    el.classList.add('is-won');
  }

  /* drill / back — delegated (only inside the drawer) */
  d.addEventListener('click', function (e) {
    var dr = e.target.closest && e.target.closest('[data-drill]');
    if (dr && dr.closest('#menu-drawer')) { e.preventDefault(); drill(dr.getAttribute('data-drill')); return; }
    var u = e.target.closest && e.target.closest('[data-up]');
    if (u && u.closest('#menu-drawer')) { e.preventDefault(); up(); return; }
  });
  /* refresh the free-ship bar on open, reset the drill on close */
  try {
    new MutationObserver(function () {
      if (d.documentElement.classList.contains('cce-nav-open')) refreshFs(); else reset();
    }).observe(d.documentElement, { attributes: true, attributeFilter: ['class'] });
  } catch (e) {}

  var tries = 0;
  (function init() { if (!build() && tries++ < 40) setTimeout(init, 250); })();
  if (d.readyState === 'loading') d.addEventListener('DOMContentLoaded', build);
  window.addEventListener('load', build);
})();

/* ============================================================
   MODULE 10 — PDP "Why a hard base?" callout (seat-cover products only).
   Mirrors the localhost pdp.css .pdp-why box; injected right after the hero
   benefit ticks on full-seat-cover / single-seat-cover / steady-ride-system.
   ============================================================ */
(function () {
  'use strict';
  var d = document;
  var handle = (location.pathname.match(/\/products\/([^\/?#]+)/) || [])[1];
  var WHY = { 'full-seat-cover': 1, 'single-seat-cover': 1, 'steady-ride-system': 1 };
  if (!handle || !WHY[handle]) return;
  function add() {
    if (d.querySelector('.cc-why-box')) return true;
    var anchor = d.querySelector('.cc-hero-points') || d.querySelector('.cc-shipping-note');
    if (!anchor || !anchor.parentNode) return false;
    var box = d.createElement('div');
    box.className = 'cc-why-box';
    box.innerHTML = '<span class="cc-why-ic" aria-hidden="true">🐾</span>' +
      '<div><b>Why a hard base?</b>' +
      '<span>Soft covers sag and slip, so your dog braces and gets anxious. Our rigid hard base stays flat — they settle in minutes.</span></div>';
    anchor.parentNode.insertBefore(box, anchor.nextSibling);
    return true;
  }
  var t = 0;
  (function init() { if (!add() && t++ < 40) setTimeout(init, 250); })();
  if (d.readyState === 'loading') d.addEventListener('DOMContentLoaded', add);
  window.addEventListener('load', add);
})();
